(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ln-atelier"] && !Shopify.designMode) return;
  try {
    


(()=>{
 function initialize(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const lifecycle=new AbortController(),on=(target,type,fn,options={})=>target?.addEventListener(type,fn,{...options,signal:lifecycle.signal});
  const q=selector=>root.querySelector(selector),qa=selector=>[...root.querySelectorAll(selector)];
  const storeHosts=new Set([location.hostname,root.dataset.shopHost,'sombreroslanutria.com','www.sombreroslanutria.com','sombreroslanutria.mx','www.sombreroslanutria.mx'].filter(Boolean));
  const spanishURL=value=>{
   if(!value||value.startsWith('#'))return value;
   try{
    const url=new URL(value,location.href);
    if(!['https:','http:'].includes(url.protocol)||!storeHosts.has(url.hostname))return value;
    const path=url.pathname.replace(/^\/en(?:-[a-z]{2})?(?=\/|$)/i,'')||'/';
    if(!/^\/(?:$|collections(?:\/|$)|products(?:\/|$)|pages(?:\/|$)|policies(?:\/|$)|blogs(?:\/|$)|search(?:\/|$)|cart(?:\/|$))/.test(path))return value;
    url.pathname=path;
    for(const key of ['locale','language','language_code']){
     if(url.searchParams.has(key))url.searchParams.set(key,root.dataset.spanishLanguage||'es');
    }
    return url.pathname+url.search+url.hash;
   }catch{return value}
  };
  const normalizeSpanishLinks=()=>qa('a[href]').forEach(link=>{
   const before=link.getAttribute('href'),after=spanishURL(before);
   if(after!==before)link.setAttribute('href',after);
  });
  normalizeSpanishLinks();
  on(root,'click',event=>{
   const link=event.target.closest('a[href]');
   if(link&&root.contains(link))link.setAttribute('href',spanishURL(link.getAttribute('href')));
  },{capture:true});
  on(root,'auxclick',normalizeSpanishLinks,{capture:true});
  on(root,'contextmenu',normalizeSpanishLinks,{capture:true});
  const languageKey='ln-spanish-language-attempt';
  const activeLanguage=(root.dataset.activeLanguage||'').toLowerCase().split('-')[0];
  if(activeLanguage==='es'){
   try{sessionStorage.removeItem(languageKey)}catch{}
  }else if(root.dataset.spanishLanguage&&!window.Shopify?.designMode){
   const form=q('form.shopify-localization-form');
   const returnTo=form?.elements.namedItem('return_to');
   if(form&&returnTo){
    let maySwitch=false;
    try{
     const lastAttempt=Number(sessionStorage.getItem(languageKey)||0);
     maySwitch=Date.now()-lastAttempt>30000;
     if(maySwitch)sessionStorage.setItem(languageKey,String(Date.now()));
    }catch{}
    if(maySwitch){
     returnTo.value=spanishURL(location.href);
     HTMLFormElement.prototype.submit.call(form);
     return;
    }
   }
  }
  const track=(action,extra={})=>{const event={event:'ln_home_interaction',action,...extra};root.dispatchEvent(new CustomEvent('ln:interaction',{detail:event,bubbles:true}));if(Array.isArray(window.dataLayer))window.dataLayer.push(event)};
  const arrowPattern=/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?/gu;
  const arrowDirection=char=>({ '←':'left','‹':'left','«':'left','❮':'left','↑':'up','↓':'down','↗':'up-right','↘':'down-right','↖':'up-left','↙':'down-left' }[char]||'right');
  const arrowPaths={right:'M4 12h15m-6-6 6 6-6 6',left:'M20 12H5m6-6-6 6 6 6',up:'M12 20V5m-6 6 6-6 6 6',down:'M12 4v15m-6-6 6 6 6-6','up-right':'M5 19 19 5M7 5h12v12','down-right':'M5 5l14 14M7 19h12V7','up-left':'M19 19 5 5m0 12V5h12','down-left':'M19 5 5 19m0-12v12h12'};
  const makeArrow=character=>{
   const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
   for(const [name,value] of Object.entries({class:'ln-icon ln-arrow ln-text-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
   path.setAttribute('d',arrowPaths[arrowDirection(character[0])]);path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;
  };
  const normalizeMenuArrows=()=>{
   const menu=q('[data-modal="menu"]');if(!menu)return;
   const walker=document.createTreeWalker(menu,NodeFilter.SHOW_TEXT),nodes=[];let node;
   while(node=walker.nextNode()){const parent=node.parentElement;if(parent?.closest('a,button,summary')&&!parent.closest('svg,script,style')&&/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮]/u.test(node.data))nodes.push(node)}
   nodes.forEach(text=>{const fragment=document.createDocumentFragment();let position=0;for(const match of text.data.matchAll(arrowPattern)){fragment.append(document.createTextNode(text.data.slice(position,match.index)),makeArrow(match[0]));position=match.index+match[0].length}fragment.append(document.createTextNode(text.data.slice(position)));text.replaceWith(fragment)});
   menu.querySelectorAll('a,button,summary,a span,button span,summary span').forEach(element=>{
    if(element.closest('svg'))return;
    for(const side of ['before','after']){
     if(element.hasAttribute('data-ln-arrow-'+side))continue;
     let content='';try{content=getComputedStyle(element,'::'+side).content||''}catch{}
     const text=content.replace(/^["']|["']$/g,'').trim();
     if(!/^[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?$/u.test(text))continue;
     element.setAttribute('data-ln-arrow-'+side,'');const svg=makeArrow(text);if(side==='before')element.prepend(svg);else element.append(svg);
    }
   });
  };
  const menu=q('[data-modal="menu"]');
  const initializeSearch=search=>{
   const q=selector=>search.querySelector(selector);
   const input=q('[data-home-query]'),results=q('[data-search-results]'),list=q('[data-search-list]'),all=q('[data-search-all]'),status=q('[data-search-status]');
  let timer=0,request=null,sequence=0,skipFocusSuggest=false;
  const clearResults=()=>{sequence++;clearTimeout(timer);request?.abort();results.hidden=true;list.replaceChildren();status.textContent='';};
  const focusWithoutSuggestions=()=>{skipFocusSuggest=true;input.focus({preventScroll:true});skipFocusSuggest=false};
  on(q('[data-close-search]'),'click',()=>{clearResults();focusWithoutSuggestions()});
  const safeURL=value=>{try{const url=new URL(value,location.origin);return ['https:','http:'].includes(url.protocol)?url:null}catch{return null}};
  const resultLinks=()=>[...list.querySelectorAll('a')];
  async function suggest(){
   const term=input.value.trim();
   if(term.length<2){clearResults();return}
   request?.abort();request=new AbortController();const current=++sequence;
   const endpoint=new URL(root.dataset.searchUrl||'/search',location.origin);endpoint.pathname=endpoint.pathname.replace(/\/$/,'')+'/suggest.json';endpoint.search='';endpoint.searchParams.set('q',term);endpoint.searchParams.set('resources[type]','product');endpoint.searchParams.set('resources[limit]','4');endpoint.searchParams.set('resources[options][unavailable_products]','last');
   try{
    const response=await fetch(endpoint.toString(),{signal:request.signal,headers:{Accept:'application/json'}});if(!response.ok)throw Error('suggestions_unavailable');
    const data=await response.json();if(current!==sequence||input.value.trim()!==term||!search.contains(document.activeElement))return;
    list.replaceChildren();
    const products=Array.isArray(data.resources?.results?.products)?data.resources.results.products.slice(0,4):[];
    products.forEach(product=>{const url=safeURL(product.url);if(!url||url.origin!==location.origin||!url.pathname.includes('/products/'))return;const item=document.createElement('li'),anchor=document.createElement('a'),title=document.createElement('span');anchor.href=spanishURL(url.href);title.textContent=String(product.title||'');const picture=typeof product.image==='string'?product.image:product.image?.url||product.image?.src||product.featured_image?.url;const imageURL=picture&&safeURL(picture);if(imageURL){const image=document.createElement('img');image.src=imageURL.href;image.alt='';image.width=52;image.height=52;image.loading='lazy';anchor.append(image)}anchor.append(title);item.append(anchor);list.append(item)});
    const count=list.children.length;results.hidden=count===0;
    status.textContent=count?String(count)+' '+root.dataset.resultStatus:root.dataset.emptySearch;
    const destination=new URL(root.dataset.searchUrl||'/search',location.origin);destination.searchParams.set('q',term);destination.searchParams.set('type','product');destination.searchParams.set('options[prefix]','last');all.href=destination.href;
   }catch(error){if(error.name==='AbortError'||current!==sequence)return;results.hidden=true;status.textContent=root.dataset.emptySearch;}
  }
  on(input,'input',()=>{clearResults();timer=setTimeout(suggest,250)});
  on(input,'focus',()=>{if(!skipFocusSuggest&&results.hidden&&input.value.trim().length>=2){clearTimeout(timer);timer=setTimeout(suggest,100)}});
  on(input,'keydown',event=>{if(event.key==='ArrowDown'&&!results.hidden&&resultLinks().length){event.preventDefault();resultLinks()[0].focus()}if(event.key==='Escape'&&!results.hidden){event.preventDefault();clearResults()}});
  on(results,'keydown',event=>{const links=resultLinks(),index=links.indexOf(document.activeElement);if(event.key==='Escape'){event.preventDefault();clearResults();focusWithoutSuggestions();return}if(index<0)return;if(event.key==='ArrowDown'){event.preventDefault();(links[index+1]||all).focus()}if(event.key==='ArrowUp'){event.preventDefault();(links[index-1]||input).focus()}});
  on(results,'pointerdown',()=>{sequence++;clearTimeout(timer);request?.abort()});
  on(search,'focusout',event=>{if(event.relatedTarget&&!search.contains(event.relatedTarget))clearResults()});
  on(search.querySelector('form'),'submit',event=>{input.value=input.value.trim();if(!input.value){event.preventDefault();input.focus();return}clearResults();track('search_submit')});
  on(document,'click',event=>{if(!search.contains(event.target))clearResults()});
   return {input,search,clear:clearResults};
  };
  const searches=qa('[data-home-search]').map(initializeSearch);
  qa('[data-track]').forEach(link=>on(link,'click',()=>track(link.dataset.track)));
  const searchDialog=q('[data-modal="search"]');
  const viewport=window.visualViewport;
  const updateSearchViewport=()=>{
   if(!searchDialog)return;
   const height=viewport?.height||window.innerHeight,width=viewport?.width||window.innerWidth;
   searchDialog.style.setProperty('--ln-visual-height',height+'px');searchDialog.style.setProperty('--ln-visual-width',width+'px');searchDialog.style.setProperty('--ln-visual-top',Math.max(0,viewport?.offsetTop||0)+'px');searchDialog.style.setProperty('--ln-visual-left',Math.max(0,viewport?.offsetLeft||0)+'px');searchDialog.classList.toggle('is-short',height<300);
  };
  on(viewport,'resize',updateSearchViewport,{passive:true});on(viewport,'scroll',updateSearchViewport,{passive:true});on(window,'resize',updateSearchViewport,{passive:true});updateSearchViewport();
  const dialogs=qa('dialog[data-modal]'),dialogOpeners=new WeakMap(),skipReturn=new WeakSet();
  const syncMenu=()=>qa('[data-dialog][aria-expanded]').forEach(button=>button.setAttribute('aria-expanded',String(Boolean(dialogs.find(dialog=>dialog.dataset.modal===button.dataset.dialog)?.open))));
  const closeDialog=(dialog,restoreFocus=true)=>{if(!dialog?.open)return;if(!restoreFocus)skipReturn.add(dialog);dialog.close();syncMenu()};
  const openDialog=(dialog,opener)=>{
   if(!dialog||dialog.open)return;
   const parent=opener?.closest('dialog'),returnTo=parent?(dialogOpeners.get(parent)||opener):opener;
   dialogs.forEach(other=>{if(other!==dialog)closeDialog(other,false)});
   dialogOpeners.set(dialog,returnTo);updateSearchViewport();dialog.showModal();syncMenu();
   if(dialog===menu)normalizeMenuArrows();
   if(dialog===searchDialog){const field=dialog.querySelector('[data-home-query]');field?.focus({preventScroll:true});updateSearchViewport()}
   track(dialog.dataset.modal==='size'?'size_guide_open':'dialog_open',{dialog:dialog.dataset.modal});
  };
  on(root,'click',event=>{
   const close=event.target.closest('[data-close]');if(close){closeDialog(close.closest('dialog'));return}
   const trigger=event.target.closest('[data-dialog]');if(!trigger||!root.contains(trigger))return;
   event.preventDefault();
   openDialog(dialogs.find(dialog=>dialog.dataset.modal===trigger.dataset.dialog),trigger);
  });
  dialogs.forEach(dialog=>{
   on(dialog,'close',()=>{searches.filter(search=>dialog.contains(search.search)).forEach(search=>search.clear());syncMenu();const skip=skipReturn.delete(dialog);if(!skip&&!dialogs.some(item=>item.open))dialogOpeners.get(dialog)?.focus({preventScroll:true})});
   on(dialog,'cancel',event=>{event.preventDefault();closeDialog(dialog)});
   on(dialog,'click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog(dialog)});
  });
  const measureForm=q('[data-measure-form]');
  on(measureForm,'submit',event=>{event.preventDefault();if(!measureForm.reportValidity())return;const measure=Number(measureForm.elements.measure.value);if(!Number.isFinite(measure))return;const output=q('[data-measure-result]'),text=Number.isInteger(measure)?output.dataset.whole:output.dataset.between;output.textContent=(text||'').replace('__MEASURE__',String(measure)).replace('__LOWER__',String(Math.floor(measure))).replace('__UPPER__',String(Math.ceil(measure)));const link=q('[data-measure-whatsapp]'),url=new URL(link.href);if(measureForm.dataset.message)url.searchParams.set('text',measureForm.dataset.message.replace('__MEASURE__',String(measure)));link.href=url.toString();track('size_guide_used')});
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const slider=q('[data-hero-slider]');
  if(slider){
   const slides=[...slider.querySelectorAll('[data-hero-slide]')],stage=slider.querySelector('[data-hero-slides]'),controls=slider.querySelector('[data-hero-controls]'),toggle=slider.querySelector('[data-hero-toggle]'),status=slider.querySelector('[data-hero-status]');
   const interval=Math.max(5000,Number(slider.dataset.interval)||8000);
   let current=0,timer=0,hovering=false,inView=true,userPaused=slider.dataset.autoplay==='false'||Boolean(window.Shopify?.designMode),pointer=null,ignoreClickUntil=0,sliderObserver;
   const stop=()=>{clearTimeout(timer);timer=0};
   const canRotate=()=>!userPaused&&!hovering&&inView&&!document.hidden&&!reduced.matches&&root.isConnected;
   const scheduleSlide=()=>{stop();if(canRotate())timer=setTimeout(()=>{if(canRotate()&&!q('dialog[open]'))showSlide(current+1,false);scheduleSlide()},interval)};
   const syncRotation=()=>{
    const paused=userPaused||reduced.matches;
    toggle.hidden=reduced.matches;
    toggle.setAttribute('aria-label',paused?slider.dataset.playLabel:slider.dataset.pauseLabel);
    toggle.setAttribute('title',paused?slider.dataset.playLabel:slider.dataset.pauseLabel);
    toggle.querySelector('[data-hero-pause-icon]').toggleAttribute('hidden',paused);
    toggle.querySelector('[data-hero-play-icon]').toggleAttribute('hidden',!paused);
    scheduleSlide();
   };
   const showSlide=(index,manual=true)=>{
    const next=(index+slides.length)%slides.length;
    if(manual)userPaused=true;
    const focusWasInSlide=slides[current].contains(document.activeElement);
    if(next!==current){
     stage.classList.remove('is-changing');
     slides.forEach((slide,i)=>{const active=i===next;slide.hidden=!active;slide.inert=!active;slide.setAttribute('aria-hidden',String(!active))});
     current=next;
     if(!reduced.matches){void stage.offsetWidth;stage.classList.add('is-changing')}
     if(focusWasInSlide)slider.querySelector('[data-hero-next]').focus({preventScroll:true});
     if(manual){status.textContent=slider.dataset.statusTemplate.replace('__CURRENT__',String(current+1)).replace('__TOTAL__',String(slides.length));track('hero_slide_change',{slide:current+1})}
    }
    syncRotation();
   };
   on(slider.querySelector('[data-hero-prev]'),'click',()=>showSlide(current-1));
   on(slider.querySelector('[data-hero-next]'),'click',()=>showSlide(current+1));
   on(toggle,'click',()=>{userPaused=!userPaused;syncRotation()});
   on(slider,'focusin',event=>{if(event.target!==toggle){userPaused=true;syncRotation()}});
   on(slider,'pointerenter',event=>{if(event.pointerType==='mouse'){hovering=true;stop()}});
   on(slider,'pointerleave',event=>{if(event.pointerType==='mouse'){hovering=false;scheduleSlide()}});
   on(slider,'keydown',event=>{if(event.altKey||event.ctrlKey||event.metaKey||event.shiftKey)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showSlide(current+(event.key==='ArrowRight'?1:-1))}});
   on(stage,'pointerdown',event=>{if(event.pointerType==='mouse'||!event.isPrimary||event.target.closest('a,button'))return;pointer={id:event.pointerId,x:event.clientX,y:event.clientY};stop()},{passive:true});
   on(stage,'pointerup',event=>{if(!pointer||pointer.id!==event.pointerId)return;const dx=event.clientX-pointer.x,dy=event.clientY-pointer.y;pointer=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){ignoreClickUntil=Date.now()+400;showSlide(current+(dx<0?1:-1))}else scheduleSlide()},{passive:true});
   on(stage,'pointercancel',()=>{pointer=null;scheduleSlide()},{passive:true});
   on(stage,'click',event=>{if(Date.now()<ignoreClickUntil){event.preventDefault();event.stopImmediatePropagation()}},{capture:true});
   on(document,'visibilitychange',scheduleSlide);
   on(reduced,'change',syncRotation);
   if('IntersectionObserver' in window){sliderObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;scheduleSlide()},{threshold:0});sliderObserver.observe(slider)}
   const castorLink=slider.querySelector('[data-castor-advice="true"]');
   if(castorLink){try{const url=new URL(castorLink.href);if(url.hostname==='wa.me'||url.hostname==='api.whatsapp.com'){url.searchParams.set('text',castorLink.dataset.castorMessage);castorLink.href=url.href}}catch{}}
   lifecycle.signal.addEventListener('abort',()=>{stop();sliderObserver?.disconnect()},{once:true});
   controls.hidden=false;
   syncRotation();
  }

  qa('[data-view-choice]').forEach(button=>on(button,'click',()=>{
   const change=()=>{q('.ln-view-images').dataset.view=button.dataset.viewChoice;qa('[data-view-choice]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)))};
   if(!reduced.matches&&typeof document.startViewTransition==='function')document.startViewTransition(change);else change();track('product_view_angle',{angle:button.dataset.viewChoice});
  }));
  qa('a[href^="#"]:not([data-dialog])').forEach(link=>on(link,'click',event=>{const target=document.getElementById(link.getAttribute('href').slice(1));if(!target||!root.contains(target))return;event.preventDefault();closeDialog(menu,false);target.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});if(!target.hasAttribute('tabindex'))target.tabIndex=-1;target.focus({preventScroll:true})}));
  qa('.ln-faq details').forEach(detail=>on(detail,'toggle',()=>{if(detail.open)qa('.ln-faq details').forEach(other=>{if(other!==detail)other.open=false})}));
  qa('[id^="ln-models-"]').forEach(section=>{if(!section.querySelector('.ln-product'))section.hidden=true});
  const hero=q('[data-hero-slider]')||q('.ln-hero'),header=q('.ln-header'),dock=q('.ln-mobile-dock');let frame=0;
  const updateScroll=()=>{frame=0;if(!root.isConnected)return;const bounds=hero?.getBoundingClientRect();header?.classList.toggle('is-scrolled',Boolean(bounds&&bounds.top < -50));dock?.classList.toggle('is-visible',Boolean(bounds&&bounds.bottom<0))};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(updateScroll)};
  on(window,'scroll',schedule,{passive:true});on(window,'resize',schedule,{passive:true});updateScroll();
  let sectionObserver;
  if('IntersectionObserver' in window){sectionObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){track('section_view',{section:entry.target.id});sectionObserver.unobserve(entry.target)}}),{threshold:.2});qa('section[id]').forEach(section=>sectionObserver.observe(section))}

  on(document,'shopify:section:unload',event=>{if(event.target.contains(root)){searches.forEach(search=>search.clear());dialogs.forEach(dialog=>closeDialog(dialog,false));lifecycle.abort();sectionObserver?.disconnect();if(frame)cancelAnimationFrame(frame)}});
 }
 document.querySelectorAll('[data-ux-home]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ux-home]').forEach(initialize));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-cart"] && !Shopify.designMode) return;
  try {
    

(() => {

  window.__LN_CART_CRO_STOP?.();

  const life = new AbortController();

  let active;

  function init() {

    const root = document.getElementById('ln-cart-page-v8');

    if (!root || root.dataset.lnCartVersion !== '12' || active?.root === root) return;

    active?.stop();

    let cfg;

    try { cfg = JSON.parse(root.querySelector('[data-ln-cart-config]').textContent); } catch { return; }

    if (!window.fetch || !window.DOMParser) return;

    cfg.root = (cfg.root || '/').replace(/\/?$/, '/');

    const ctl = new AbortController(), q = s => root.querySelector(s), qa = s => [...root.querySelectorAll(s)];

    const form = q('[data-ln-cart-form]'), wallet = q('[data-ln-payments-persistent]');

    const on = (node, type, handler, capture = false) => node.addEventListener(type, handler, {signal: ctl.signal, capture});

    const say = key => cfg.messages[key];

    let busy = false, uncertain = false, checkoutWanted = false, leaving = false, timer, observer;

    let acceptedImportCountry = '';

    let savedNote = q('[name="note"]')?.value || '', draft = savedNote;

    const alive = () => root.isConnected && !ctl.signal.aborted;

    const rows = () => qa('[data-key]');

    const matchingRow = change => rows().find(row => row.dataset.key === change.key) || (() => {

      const matches = rows().filter(row => row.dataset.identity === change.identity);

      return matches.length === 1 ? matches[0] : null;

    })();

    const maxFor = input => input.dataset.max === '' ? Infinity : Number(input.dataset.max);

    const changes = () => qa('input[name="updates[]"]').filter(input => input.value.trim() === '' || Number(input.value) !== Number(input.dataset.saved)).map(input => ({input, key: input.closest('[data-key]').dataset.key, identity: input.closest('[data-key]').dataset.identity, quantity: Number(input.value)}));

    function message(text, error = false) {

      const el = q('[data-ln-feedback]');

      el.hidden = !text;

      el.textContent = text || '';

      el.classList.toggle('is-error', error);

      el.setAttribute('role', error ? 'alert' : 'status');

      if (error) el.focus();

    }

    function importRequired() {
      return q('[data-ln-cart-content]')?.dataset.importRequired === 'true';
    }
    function importAccepted() {
      return !importRequired() || q('[data-ln-import-accept]')?.checked === true;
    }
    function focusImport() {
      const input = q('[data-ln-import-accept]');
      q('[data-ln-import-box]')?.scrollIntoView({behavior: 'auto', block: 'center'});
      input?.focus({preventScroll: true});
    }
    function validateImport() {
      if (importAccepted()) return true;
      checkoutWanted = false;
      message(say('import_required'), true);
      focusImport();
      return false;
    }

    function validate(inputs) {

      for (const input of inputs) {

        const n = Number(input.value), min = Number(input.dataset.min) || 1, step = Number(input.dataset.step) || 1;

        if (input.value.trim() === '' || !Number.isSafeInteger(n) || n < 0 || (n !== 0 && (n < min || (n - min) % step !== 0 || n > maxFor(input)))) {

          checkoutWanted = false;

          message(n > maxFor(input) ? say('stock_error') : say('quantity_error'), true);

          input.focus();

          return false;

        }

      }

      return true;

    }

    function ui() {

      const content = q('[data-ln-cart-content]'), count = Number(content.dataset.count) || 0;

      const pending = changes().length > 0, locked = busy || uncertain || leaving;

      root.classList.add('ln-ready');

      root.setAttribute('aria-busy', String(busy || leaving));

      qa('[data-ln-qty]').forEach(button => { button.hidden = false; button.disabled = locked; });

      qa('input[name="updates[]"]').forEach(input => {

        input.disabled = locked;

        const plus = input.closest('[data-key]').querySelector('[data-ln-qty="plus"]');

        const n = Number(input.value), min = Number(input.dataset.min) || 1, step = Number(input.dataset.step) || 1;

        plus.disabled = locked || (n < min ? min : n + step) > maxFor(input);

      });

      qa('.ln-remove,[data-ln-whatsapp]').forEach(link => { link.inert = locked || (link.hasAttribute('data-ln-whatsapp') && pending); });

      qa('button[name="checkout"]').forEach(button => {

        button.disabled = uncertain || leaving || !count || !importAccepted();

        button.textContent = checkoutWanted || leaving ? say('working') : busy || pending ? say('updating') : say('checkout');

      });

      const importBlocked = !importAccepted();
      const review = q('[data-ln-import-review]');
      if (review) { review.hidden = !importBlocked || !count; review.disabled = locked; }
      const stickyCheckout = q('[data-ln-sticky] button[name="checkout"]');
      if (stickyCheckout) stickyCheckout.hidden = importBlocked;

      if (wallet) {

        const slot = q('[data-ln-payments-slot]');

        if (slot && wallet.parentNode !== slot) slot.append(wallet);

        wallet.hidden = !slot || !count || draft !== savedNote || importRequired();

        wallet.inert = locked || pending || importRequired();

      }

      q('[data-ln-retry]').hidden = !uncertain;

      q('[data-ln-sticky-total]').textContent = busy || pending ? say('updating') : content.dataset.total;

      const sticky = q('[data-ln-sticky]'), primary = q('.ln-summary button[name="checkout"]');

      observer?.disconnect();

      sticky.hidden = !count || !primary;

      if (primary && window.IntersectionObserver) {

        observer = new IntersectionObserver(entries => { sticky.hidden = !count || entries[0].isIntersecting; });

        observer.observe(primary);

      }

      document.querySelectorAll('[data-cart-count],.cart-bubble__text-count').forEach(el => { if (!root.contains(el)) el.textContent = String(count); });

      document.querySelectorAll('.cart-count-bubble').forEach(el => {

        if (root.contains(el)) return;

        el.hidden = !count;

        const visible = el.querySelector('[aria-hidden="true"]');

        if (visible) visible.textContent = String(count);

      });

    }

    async function request(url, body, text = false) {

      const abort = new AbortController(), cancel = () => abort.abort(), clock = setTimeout(cancel, 12000);

      ctl.signal.addEventListener('abort', cancel, {once: true});

      try {

        const options = {credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: {Accept: text ? 'text/html' : 'application/json'}};

        if (body) {

          options.method = 'POST';

          options.headers['Content-Type'] = 'application/json';

          options.body = JSON.stringify({...body, sections: [cfg.section], sections_url: cfg.cart});

        }

        const response = await fetch(url, options);

        const data = text ? await response.text() : await response.json();

        if (!response.ok || Number(data.status) >= 400) {

          const error = new Error(typeof data.description === 'string' ? data.description : say('network_error'));

          error.uncertain = !!body && response.status >= 500;

          throw error;

        }

        return data;

      } catch (error) {

        if (error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError) {

          const issue = new Error(say('network_error'));

          issue.uncertain = !!body;

          throw issue;

        }

        throw error;

      } finally { clearTimeout(clock); ctl.signal.removeEventListener('abort', cancel); }

    }

    async function refresh(data) {

      const parse = html => typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html').getElementById('ln-cart-page-v8') : null;

      let next = parse(data?.sections?.[cfg.section]);

      if (!next) {

        const url = new URL(cfg.cart, location.origin);

        url.searchParams.set('sections', cfg.section);

        const sections = await request(url.href);

        next = parse(sections?.[cfg.section]);

      }

      if (!next) next = parse(await request(cfg.cart, undefined, true));

      const fresh = next?.querySelector('[data-ln-cart-content]');

      if (!fresh) throw new Error(say('reload_error'));

      if (!alive()) return;

      const opened = qa('details[open]').map(el => el.className);

      const focused = document.activeElement;

      const identity = focused?.closest('[data-key]')?.dataset.identity;

      const wasNote = focused?.name === 'note';

      const dirtyNote = draft !== savedNote;

      if (wallet) q('.ln-cart-inner').append(wallet);

      const content = q('[data-ln-cart-content]');

      content.innerHTML = fresh.innerHTML;

      content.dataset.count = fresh.dataset.count;

      content.dataset.total = fresh.dataset.total;
      content.dataset.importRequired = fresh.dataset.importRequired;
      content.dataset.country = fresh.dataset.country;
      if (acceptedImportCountry !== content.dataset.country || !importRequired()) acceptedImportCountry = '';
      const acceptance = q('[data-ln-import-accept]');
      if (acceptance) acceptance.checked = acceptedImportCountry === content.dataset.country;

      savedNote = q('[name="note"]')?.value || '';

      if (!dirtyNote) draft = savedNote;

      if (q('[name="note"]')) q('[name="note"]').value = draft;

      qa('details').forEach(el => { if (opened.includes(el.className)) el.open = true; });

      ui();

      if (wasNote) q('[name="note"]')?.focus({preventScroll: true});

      else if (identity) root.dataset.lnFocusIdentity = identity;

    }

    function checkout() {

      if (!Number(q('[data-ln-cart-content]').dataset.count) || uncertain || leaving) return;

      if (!validateImport() || !validate(qa('input[name="updates[]"]'))) return;

      leaving = true;

      ui();

      qa('input[name="updates[]"]').forEach(input => { input.disabled = false; });

      const note = q('[name="note"]');

      if (note) note.value = draft;

      const submit = document.createElement('input');

      submit.type = 'hidden'; submit.name = 'checkout'; submit.value = 'checkout';

      form.append(submit);

      HTMLFormElement.prototype.submit.call(form);

      submit.remove();

    }

    async function run(wantsCheckout = false, refreshOnly = false) {

      if (leaving || !alive()) return;

      if (wantsCheckout && !validateImport()) { ui(); return; }

      if (wantsCheckout) checkoutWanted = true;

      if (busy) { ui(); return; }

      if (uncertain && !refreshOnly) return;

      clearTimeout(timer);

      const pending = changes();

      if (!validate(pending.map(change => change.input))) { ui(); return; }

      if (!pending.length && !refreshOnly) { if (checkoutWanted) checkout(); checkoutWanted = false; return; }

      busy = true; message(''); ui();

      try {

        if (refreshOnly) { await refresh(); uncertain = false; }

        for (const change of pending) {

          const row = matchingRow(change);

          if (!row) throw new Error(say('reload_error'));

          await refresh(await request(cfg.root + 'cart/change.js', {id: row.dataset.key, quantity: change.quantity}));

          const updated = matchingRow(change);

          const actual = Number(updated?.querySelector('input[name="updates[]"]')?.dataset.saved) || 0;

          if (actual !== change.quantity) throw new Error(say('stock_error'));

        }

        if (checkoutWanted) checkout();

        else if (pending.length) message(say('updated'));

      } catch (error) {

        checkoutWanted = false;

        try { await refresh(); uncertain = false; } catch { uncertain = true; }

        if (error.uncertain) uncertain = true;

        message(uncertain ? say('reload_error') : error.message || say('network_error'), true);

      } finally {

        busy = false; checkoutWanted = false;

        if (alive()) {

          ui();

          if (!leaving && !uncertain && root.dataset.lnFocusIdentity) rows().find(row => row.dataset.identity === root.dataset.lnFocusIdentity)?.querySelector('input')?.focus({preventScroll: true});

          delete root.dataset.lnFocusIdentity;

        }

      }

    }

    on(root, 'change', event => {
      if (!event.target.matches('[data-ln-import-accept]')) return;
      acceptedImportCountry = event.target.checked ? q('[data-ln-cart-content]').dataset.country : '';
      if (!event.target.checked) checkoutWanted = false;
      message('');
      ui();
    });

    on(root, 'input', event => {

      if (event.target.name === 'note') { draft = event.target.value; ui(); }

      if (event.target.name === 'updates[]') { clearTimeout(timer); ui(); timer = setTimeout(() => run(), 600); }

    });

    on(root, 'click', event => {
      if (event.target.closest('[data-ln-import-review]')) { event.preventDefault(); focusImport(); return; }


      const control = event.target.closest('[data-ln-qty],.ln-remove');

      if (!control || !root.contains(control)) return;

      event.preventDefault(); event.stopPropagation();

      if (busy || uncertain || leaving) return;

      const input = control.closest('[data-key]').querySelector('input[name="updates[]"]');

      const n = Number(input.value), min = Number(input.dataset.min) || 1, step = Number(input.dataset.step) || 1;

      input.value = control.matches('.ln-remove') ? 0 : control.dataset.lnQty === 'minus' ? (n <= min ? 0 : Math.max(min, n - step)) : (n < min ? min : n + step);

      run();

    }, true);

    on(form, 'submit', event => {

      event.preventDefault(); event.stopImmediatePropagation();

      run(event.submitter?.name !== 'update');

    }, true);

    on(window, 'pageshow', event => { if (event.persisted) { leaving = false; checkoutWanted = false; busy = false; run(false, true); } });

    on(document, 'visibilitychange', () => { if (document.visibilityState === 'visible' && !busy && !leaving && !changes().length) run(false, true); });

    active = {root, stop: () => { clearTimeout(timer); observer?.disconnect(); ctl.abort(); }};

    ui();

  }

  window.__LN_CART_CRO_STOP = () => { life.abort(); active?.stop(); };

  document.addEventListener('shopify:section:load', init, {signal: life.signal});

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true, signal: life.signal});

  else init();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-collection-directory"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const controller=new AbortController(),on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal:controller.signal});const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];const reduce=matchMedia('(prefers-reduced-motion:reduce)');let previous=null,overflow='';const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('is-pending');observer.unobserve(e.target)}}),{threshold:.04}):null;qa('.lnw-reveal').forEach((el,i)=>{el.style.setProperty('--reveal-delay',(i%2)*65+'ms');if(!reduce.matches&&observer){el.classList.add('is-pending');observer.observe(el)}});on(reduce,'change',()=>{if(reduce.matches)qa('.is-pending').forEach(el=>el.classList.remove('is-pending'))});on(root,'click',e=>{const el=e.target.closest('a,button');if(!el)return;if(el.dataset.dialog){e.preventDefault();const dialog=q('[data-modal="'+el.dataset.dialog+'"]');if(!dialog)return;qa('dialog[open]').forEach(d=>d.close());previous=el;overflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal()}if(el.hasAttribute('data-close'))el.closest('dialog').close()});on(root,'close',()=>{if(!q('dialog[open]'))document.documentElement.style.overflow=overflow;previous?.focus({preventScroll:true})},{capture:true});let frame=false;const scroll=()=>{frame=false;const fixed=scrollY>120;q('.lnw-head')?.classList.toggle('is-scrolled',fixed);q('.lnw-head-space')?.toggleAttribute('hidden',!fixed)};on(window,'scroll',()=>{if(!frame){frame=true;requestAnimationFrame(scroll)}},{passive:true});scroll();q('[data-directory-count]').textContent=qa('[data-directory-card]').length+' colecciones para explorar';const normalize=s=>s.toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g,'');on(q('[data-collection-search]'),'input',e=>{const term=normalize(e.target.value);let count=0;qa('[data-directory-card]').forEach(card=>{card.hidden=!normalize(card.dataset.search).includes(term);if(!card.hidden){count++;card.classList.remove('is-pending')}});qa('.lnw-directory-group').forEach(g=>g.hidden=![...g.querySelectorAll('[data-directory-card]')].some(c=>!c.hidden));q('[data-directory-count]').textContent=count+' colecciones para explorar';q('[data-directory-empty]').hidden=count>0});on(document,'shopify:section:unload',e=>{if(e.target.contains(root)){controller.abort();observer?.disconnect()}})}document.querySelectorAll('[data-ln-directory]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ln-directory]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-collection"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const life = new AbortController();
    const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, {...options, signal: life.signal});
    const q = s => root.querySelector(s);
    const qa = s => [...root.querySelectorAll(s)];
    const native = root.dataset.mode === 'native';
    // Conserva idioma y mercado en las peticiones Ajax.
    const routeRoot = (window.Shopify?.routes?.root || root.dataset.rootUrl || '/').replace(/\/+$/, '') + '/';
    const messages = JSON.parse(q('[data-lnw-messages]').textContent);
    const say = (key, values = {}) => Object.entries(values).reduce((text,[k,v]) => text.replaceAll('{'+k+'}',String(v)), messages[key] || key);
    const currency = root.dataset.currency || 'MXN';
    const money = n => new Intl.NumberFormat(root.dataset.locale || 'es-MX',{style:'currency',currency,maximumFractionDigits:n % 100 ? 2 : 0}).format(n / 100);
    const escape = value => String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let lastFocus, savedOverflow = '', fetchController, quickController, quickProduct, selected = [], observer, adding=false;
    const track = (action, extra={}) => {
      const event = {event:'ln_collection_interaction',action,collection:root.dataset.collection || 'western',...extra};
      root.dispatchEvent(new CustomEvent('ln:collection',{bubbles:true,detail:event}));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(event);
    };
  const arrowPattern=/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?/gu;
  const arrowDirection=char=>({ '←':'left','‹':'left','«':'left','❮':'left','↑':'up','↓':'down','↗':'up-right','↘':'down-right','↖':'up-left','↙':'down-left' }[char]||'right');
  const arrowPaths={right:'M4 12h15m-6-6 6 6-6 6',left:'M20 12H5m6-6-6 6 6 6',up:'M12 20V5m-6 6 6-6 6 6',down:'M12 4v15m-6-6 6 6 6-6','up-right':'M5 19 19 5M7 5h12v12','down-right':'M5 5l14 14M7 19h12V7','up-left':'M19 19 5 5m0 12V5h12','down-left':'M19 5 5 19m0-12v12h12'};
  const makeArrow=character=>{
   const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
   for(const [name,value] of Object.entries({class:'lnw-arrow lnw-text-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
   path.setAttribute('d',arrowPaths[arrowDirection(character[0])]);path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;
  };
  const normalizeArrows=(menu=root)=>{
   if(!menu)return;
   menu.querySelectorAll('svg').forEach(svg=>{
    const paths=[...svg.querySelectorAll('path')];
    if(paths.length!==1||!/^(?:m146-6666|m10666-66|m412h15m-6-666-66|m69666-6)$/i.test((paths[0].getAttribute('d')||'').replace(/[\s,]/g,'')))return;
    svg.classList.add('lnw-arrow');
    for(const [name,value] of Object.entries({fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round'}))svg.setAttribute(name,value);
    paths[0].setAttribute('fill','none');paths[0].setAttribute('stroke','currentColor');
   });
   const walker=document.createTreeWalker(menu,NodeFilter.SHOW_TEXT),nodes=[];let node;
   while(node=walker.nextNode()){const parent=node.parentElement;if(parent?.closest('a,button,summary')&&!parent.closest('svg,script,style')&&/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮]/u.test(node.data))nodes.push(node)}
   nodes.forEach(text=>{const fragment=document.createDocumentFragment();let position=0;for(const match of text.data.matchAll(arrowPattern)){fragment.append(document.createTextNode(text.data.slice(position,match.index)),makeArrow(match[0]));position=match.index+match[0].length}fragment.append(document.createTextNode(text.data.slice(position)));text.replaceWith(fragment)});
   menu.querySelectorAll('a,button,summary,a span,button span,summary span').forEach(element=>{
    if(element.closest('svg'))return;
    for(const side of ['before','after']){
     if(element.hasAttribute('data-ln-arrow-'+side))continue;
     let content='';try{content=getComputedStyle(element,'::'+side).content||''}catch{}
     const text=content.replace(/^["']|["']$/g,'').trim();
     if(!/^[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?$/u.test(text))continue;
     element.setAttribute('data-ln-arrow-'+side,'');const svg=makeArrow(text);if(side==='before')element.prepend(svg);else element.append(svg);
    }
   });
  };
    on(q('[data-modal="menu"]'),'toggle',()=>normalizeArrows(q('[data-modal="menu"]')),{capture:true});
    const closeDialogs = () => qa('dialog[open]').forEach(d=>d.close());
    const openDialog = (name, opener = document.activeElement) => {
      const dialog = q('dialog[data-modal="'+name+'"]');
      if (!dialog || dialog.open) return;
      const focused = opener?.closest('dialog') ? (lastFocus || q('.lnw-search-trigger')) : opener;
      const hadDialog = Boolean(q('dialog[open]'));
      closeDialogs();
      lastFocus = focused;
      if(!hadDialog) savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';
      if(name === 'search') updateSearchViewport();
      dialog.showModal();if(name==='menu')normalizeArrows(dialog);syncSearchTrigger();
      if(name === 'search'){searchInput?.focus({preventScroll:true});updateSearchViewport();}
      track('open_'+name);
    };
    on(root,'close',event => {
      if(event.target.matches('dialog[data-modal="search"]')) resetSearch();
      syncSearchTrigger();
      if (!q('dialog[open]')) document.documentElement.style.overflow=savedOverflow;
      if(lastFocus?.isConnected && !q('dialog[open]')) lastFocus.focus({preventScroll:true});
    },{capture:true});
    const searchDialog = q('dialog[data-modal="search"]');
    const searchInput = q('[data-search-input]');
    const searchResults = q('[data-search-results]');
    const searchStatus = q('[data-search-status]');
    const searchAll = q('[data-search-all]');
    const searchHints = q('[data-search-hints]');
    const searchViewport = window.visualViewport;
    const syncSearchTrigger = () => qa('[data-dialog="search"][aria-expanded]').forEach(trigger=>trigger.setAttribute('aria-expanded',String(Boolean(searchDialog?.open))));
    const updateSearchViewport = () => {
      if(!searchDialog)return;
      const height=searchViewport?.height || window.innerHeight,width=searchViewport?.width || window.innerWidth;
      searchDialog.style.setProperty('--lnw-visual-height',height+'px');
      searchDialog.style.setProperty('--lnw-visual-width',width+'px');
      searchDialog.style.setProperty('--lnw-visual-top',Math.max(0,searchViewport?.offsetTop || 0)+'px');
      searchDialog.style.setProperty('--lnw-visual-left',Math.max(0,searchViewport?.offsetLeft || 0)+'px');
      searchDialog.classList.toggle('is-short',height<300);
    };
    on(searchViewport,'resize',updateSearchViewport,{passive:true});
    on(searchViewport,'scroll',updateSearchViewport,{passive:true});
    on(window,'resize',updateSearchViewport,{passive:true});
    updateSearchViewport();
    const setSearchAllLabel = term => {
      const label=document.createElement('span'),svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
      label.textContent=searchAll.dataset.label+' “'+term+'”';
      for(const [name,value] of Object.entries({class:'lnw-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
      path.setAttribute('d','M4 12h15m-6-6 6 6-6 6');path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);searchAll.replaceChildren(label,svg);
    };
    on(searchInput.closest('form'),'submit',event=>{searchInput.value=searchInput.value.trim();if(!searchInput.value){event.preventDefault();searchInput.focus({preventScroll:true});return}track('search_submit');});
    const searchCopy = (root.dataset.locale || 'es').startsWith('en') ?
      {loading:'Searching…',empty:'No matching products. Try another name, color or size.',error:'Suggestions are unavailable. Press Enter to search the store.',found:'results'} :
      {loading:'Buscando…',empty:'No encontramos productos. Prueba con otro nombre, color o talla.',error:'No se cargaron las sugerencias. Presiona Enter para buscar en la tienda.',found:'resultados'};
    const priceFormatter = new Intl.NumberFormat(root.dataset.locale || 'es-MX',{style:'currency',currency,maximumFractionDigits:2});
    let searchTimer, searchController, searchRequest = 0, activeResult = -1;
    const searchCache = new Map();
    const safeLink = (url, segment) => {
      try {
        const target = new URL(url, location.origin);
        return target.origin === location.origin && target.pathname.includes('/'+segment+'/') ? target.pathname+target.search+target.hash : null;
      } catch {return null;}
    };
    const safeImage = url => {
      try {const target = new URL(url, location.origin);return target.protocol === 'https:' ? target.href : null;}
      catch {return null;}
    };
    const resetSearch = () => {
      clearTimeout(searchTimer);searchController?.abort();searchRequest++;activeResult=-1;
      searchInput.value='';searchInput.setAttribute('aria-expanded','false');searchInput.removeAttribute('aria-activedescendant');
      searchResults.replaceChildren();searchResults.hidden=true;searchAll.hidden=true;searchHints.hidden=false;searchStatus.textContent='';
    };
    const updateSearch = (data, term) => {
      searchResults.replaceChildren();activeResult=-1;searchInput.removeAttribute('aria-activedescendant');
      const products = Array.isArray(data?.resources?.results?.products) ? data.resources.results.products.slice(0,6) : [];
      const collections = Array.isArray(data?.resources?.results?.collections) ? data.resources.results.collections.slice(0,2) : [];
      let count=0;
      const group = (label) => {
        const container=document.createElement('div');container.className='lnw-search-group';
        const heading=document.createElement('p');heading.textContent=label;container.append(heading);
        const list=document.createElement('div');list.className='lnw-search-list';list.setAttribute('role','group');list.setAttribute('aria-label',label);
        container.append(list);searchResults.append(container);return list;
      };
      if(products.length){
        const list=group(searchResults.dataset.productsLabel);
        for(const product of products){
          const href=safeLink(product.url,'products');if(!href)continue;
          const link=document.createElement('a');link.className='lnw-search-result';link.href=href;link.dataset.searchResult='product';link.id='lnw-result-'+root.dataset.sectionId+'-'+count++;link.setAttribute('role','option');link.setAttribute('aria-selected','false');
          const image=safeImage(product.image || product.featured_image?.url);
          if(image){const img=document.createElement('img');img.src=image;img.alt='';img.loading='lazy';img.width=66;img.height=66;link.append(img);}
          else {const placeholder=document.createElement('span');placeholder.className='lnw-search-placeholder';placeholder.setAttribute('aria-hidden','true');placeholder.textContent='LN';link.append(placeholder);}
          const name=document.createElement('span');name.className='lnw-search-name';name.textContent=product.title || '';
          if(product.vendor){const vendor=document.createElement('small');vendor.textContent=product.vendor;name.append(vendor);}
          link.append(name);
          const value=Number(product.price);
          if(Number.isFinite(value) && value>=0){const price=document.createElement('span');price.className='lnw-search-price';price.textContent=priceFormatter.format(value);link.append(price);}
          list.append(link);
        }
      }
      if(collections.length){
        const list=group(searchResults.dataset.collectionsLabel);
        for(const collection of collections){
          const href=safeLink(collection.url,'collections');if(!href)continue;
          const link=document.createElement('a');link.className='lnw-search-collection';link.href=href;link.dataset.searchResult='collection';link.id='lnw-result-'+root.dataset.sectionId+'-'+count++;link.setAttribute('role','option');link.setAttribute('aria-selected','false');link.textContent=collection.title || '';list.append(link);
        }
      }
      const visible=searchResults.querySelectorAll('[data-search-result]').length;
      searchResults.hidden=!visible;searchHints.hidden=Boolean(visible);searchInput.setAttribute('aria-expanded',String(Boolean(visible)));
      searchStatus.textContent=visible ? visible+' '+searchCopy.found : searchCopy.empty;
      searchAll.hidden=false;setSearchAllLabel(term);
      const url=new URL(searchAll.href,location.origin);url.searchParams.set('q',term);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');searchAll.href=url.href;
    };
    const suggest = async term => {
      const id=++searchRequest;
      searchController?.abort();searchController=new AbortController();
      searchStatus.textContent=searchCopy.loading;
      searchAll.hidden=true;searchResults.hidden=true;searchInput.setAttribute('aria-expanded','false');
      try {
        const key=term.toLocaleLowerCase();let data=searchCache.get(key);
        if(!data){
          const url=new URL(routeRoot+'search/suggest.json',location.origin);
          url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,collection');url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('resources[options][unavailable_products]','hide');
          const response=await fetch(url.href,{signal:searchController.signal,headers:{Accept:'application/json'}});
          if(!response.ok)throw new Error('Search '+response.status);
          data=await response.json();searchCache.set(key,data);
          if(searchCache.size>20)searchCache.delete(searchCache.keys().next().value);
        }
        if(id===searchRequest && searchDialog.open && searchInput.value.trim()===term)updateSearch(data,term);
      } catch(error){
        if(id!==searchRequest || error.name==='AbortError')return;
        searchResults.hidden=true;searchHints.hidden=false;searchInput.setAttribute('aria-expanded','false');
        searchStatus.textContent=searchCopy.error;
        const url=new URL(searchAll.href,location.origin);url.searchParams.set('q',term);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');searchAll.href=url.href;
        setSearchAllLabel(term);searchAll.hidden=false;
      }
    };
    on(searchInput,'input',() => {
      clearTimeout(searchTimer);searchController?.abort();searchRequest++;activeResult=-1;
      searchInput.removeAttribute('aria-activedescendant');
      const term=searchInput.value.trim();
      if(term.length<2){searchResults.replaceChildren();searchResults.hidden=true;searchHints.hidden=false;searchAll.hidden=true;searchStatus.textContent='';searchInput.setAttribute('aria-expanded','false');return;}
      searchResults.hidden=true;searchHints.hidden=true;searchAll.hidden=true;searchInput.setAttribute('aria-expanded','false');
      searchTimer=setTimeout(()=>suggest(term),240);
    });
    on(searchInput,'keydown',event => {
      if(!['ArrowDown','ArrowUp','Enter'].includes(event.key) || searchResults.hidden)return;
      const options=[...searchResults.querySelectorAll('[data-search-result]')];if(!options.length)return;
      if(event.key==='Enter'){if(activeResult<0)return;event.preventDefault();track('search_suggestion_open',{type:options[activeResult].dataset.searchResult});location.assign(options[activeResult].href);return;}
      event.preventDefault();
      activeResult=event.key==='ArrowDown'?(activeResult+1)%options.length:(activeResult-1+options.length)%options.length;
      for(const option of options)option.setAttribute('aria-selected',String(option===options[activeResult]));
      searchInput.setAttribute('aria-activedescendant',options[activeResult].id);
      const scrollArea=q('[data-search-scroll]'),area=scrollArea.getBoundingClientRect(),option=options[activeResult].getBoundingClientRect();
      if(option.bottom>area.bottom)scrollArea.scrollTop+=option.bottom-area.bottom;
      else if(option.top<area.top)scrollArea.scrollTop-=area.top-option.top;
    });
    function reveal(scope=root) {
      normalizeArrows(scope);
      const elements = [...scope.querySelectorAll('.lnw-reveal')];
      elements.forEach((el,i)=>{
        el.style.setProperty('--reveal-delay',(i % (innerWidth<801?2:4))*65+'ms');
        if (!motion.matches && observer && el.getBoundingClientRect().top>innerHeight*.9) {
          el.classList.add('is-pending');observer.observe(el);
        }
      });
    }
    if ('IntersectionObserver' in window) observer=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){e.target.classList.remove('is-pending');observer.unobserve(e.target);}
    }),{rootMargin:'0px 0px -20px 0px',threshold:.04});
    on(motion,'change',()=>{if(motion.matches)qa('.is-pending').forEach(e=>e.classList.remove('is-pending'));schedule();});
    let pendingFrame=false;
    const updateScroll=()=>{
      pendingFrame=false;
      const header=q('.lnw-head');const fixed=scrollY>120;
      header?.classList.toggle('is-scrolled',fixed);
      q('.lnw-head-space')?.toggleAttribute('hidden',!fixed);
      const hero=q('.lnw-hero');const rect=hero?.getBoundingClientRect();
      if(rect && !motion.matches && rect.bottom>0) hero.style.setProperty('--hero-shift',Math.max(-20,Math.min(20,-rect.top*.065))+'px');
      q('.lnw-dock')?.classList.toggle('is-visible',Boolean(rect && rect.bottom<75));
    };
    const schedule=()=>{if(!pendingFrame){pendingFrame=true;requestAnimationFrame(updateScroll);}};
    on(window,'scroll',schedule,{passive:true});on(window,'resize',schedule,{passive:true});
    const scrollProducts = () => q('[data-collection-zone]').scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'start'});
    const allProducts = native ? [] : JSON.parse(q('[data-preview-products]').textContent);
    let demoState, demoPageSize=24;
    const readState = () => {
      const u=new URL(location.href), p=u.searchParams;
      return {style:p.get('estilo')||'all',vendors:p.getAll('filter.p.vendor'),sizes:p.getAll('filter.v.option.talla'),min:Number(p.get('filter.v.price.gte'))||0,max:Number(p.get('filter.v.price.lte'))||0,sort:p.get('sort_by')||'manual',page:Math.max(1,Number(p.get('page'))||1)};
    };
    const productVariants = product => product.variants.filter(v=>{
      const sizeIndex=product.options.findIndex(o=>/talla|size/i.test(o));
      return (!demoState.sizes.length || (sizeIndex>=0 && demoState.sizes.includes(v.options[sizeIndex]))) && (!demoState.min || v.price>=demoState.min*100) && (!demoState.max || v.price<=demoState.max*100);
    });
    const shorten = p => p.title.replace(new RegExp('^'+p.vendor+'\\s*','i'),'').replace(' – Sombrero Vaquero Artesanal de México','');
    const arrow = '<svg class="lnw-icon lnw-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12h15m-6-6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
    const productCard = p => {
      const sizeIndex=p.options.findIndex(o=>/talla|size/i.test(o));
      const sizes=sizeIndex<0?[]:[...new Set(p.variants.map(v=>v.options[sizeIndex]))];
      const note=p.kind==='accessory'?say('accessory_note'):sizes.length===1 && /unitalla/i.test(sizes[0])?say('one_size'):sizes.length?say('sizes_short',{sizes:sizes.join(', ')}):say('view_options');
      return '<article class="lnw-card lnw-reveal lnw-revealing" data-product-card="'+p.id+'">'+
        '<a class="lnw-card-media" href="'+escape(p.url)+'" aria-label="'+escape(p.title)+'">'+p.images.slice(0,2).map((url,i)=>'<img src="'+escape(url)+'" alt="'+escape(i?'':p.title)+'" width="700" height="700" loading="lazy" decoding="async">').join('')+'</a><div class="lnw-card-copy"><p class="lnw-card-brand">'+escape(p.vendor)+'</p><h3><a href="'+escape(p.url)+'">'+escape(shorten(p))+'</a></h3><p class="lnw-card-price">'+(p.priceMax>p.price?say('from')+' ':'')+escape(money(p.price))+' <small>'+escape(currency)+'</small></p><p class="lnw-card-options">'+escape(note)+'</p><button class="lnw-btn lnw-btn--outline" data-quick="'+p.id+'" type="button">'+escape(say(p.available?(p.kind==='accessory'?'view_detail':'choose_size'):'consult'))+arrow+'</button></div></article>';
    };
    function renderPreview() {
      demoState=readState();
      let products=allProducts.filter(p=>(demoState.style==='all'||p.style.includes(demoState.style))&&(!demoState.vendors.length||demoState.vendors.includes(p.vendor))&&productVariants(p).length);
      const sorter={manual:(a,b)=>a.order-b.order,'price-ascending':(a,b)=>a.price-b.price,'price-descending':(a,b)=>b.price-a.price,'title-ascending':(a,b)=>a.title.localeCompare(b.title,'es'),'created-descending':(a,b)=>b.created.localeCompare(a.created)}[demoState.sort];
      if(sorter)products.sort(sorter);
      const pages=Math.max(1,Math.ceil(products.length/demoPageSize));demoState.page=Math.min(demoState.page,pages);
      const start=(demoState.page-1)*demoPageSize, shown=products.slice(start,start+demoPageSize);
      q('[data-product-grid]').innerHTML=shown.map(productCard).join('');
      q('[data-empty]').hidden=products.length>0;
      q('[data-result-count]').textContent=say('model_count',{count:products.length});
      q('[data-progress-text]').textContent=products.length?say('progress',{start:start+1,end:start+shown.length,total:products.length}):say('model_count',{count:0});
      const progress=q('progress');progress.max=Math.max(1,products.length);progress.value=start+shown.length;
      const pagination=q('[data-pagination]');pagination.innerHTML='';
      for(const [page,label] of [[demoState.page-1,'previous'],[demoState.page+1,'next']]){
        if(page<1||page>pages)continue;
        const url=new URL(location.href);url.searchParams.set('page',page);url.hash='lnw-products';
        pagination.insertAdjacentHTML('beforeend','<a class="lnw-btn lnw-btn--outline" data-demo-nav href="'+escape(url.pathname+url.search+url.hash)+'">'+escape(say(label))+'</a>');
      }
      qa('[data-style]').forEach(a=>{a.setAttribute('aria-current',a.dataset.style===demoState.style?'page':'false');const u=new URL(location.href);u.searchParams.delete('page');if(a.dataset.style==='all')u.searchParams.delete('estilo');else u.searchParams.set('estilo',a.dataset.style);u.hash='lnw-products';a.href=u.pathname+u.search+u.hash;});
      qa('[data-brand]').forEach(a=>{const brand=a.dataset.brand;const active=brand?demoState.vendors.includes(brand):!demoState.vendors.length;a.setAttribute('aria-current',active?'true':'false');const u=new URL(location.href);u.searchParams.delete('page');u.searchParams.delete('filter.p.vendor');if(brand&&!active)u.searchParams.set('filter.p.vendor',brand);u.hash='lnw-products';a.href=u.pathname+u.search+u.hash;});
      const tags=[];
      for(const [key,values] of [['filter.p.vendor',demoState.vendors],['filter.v.option.talla',demoState.sizes]])for(const value of values){const u=new URL(location.href);u.searchParams.delete(key);values.filter(v=>v!==value).forEach(v=>u.searchParams.append(key,v));u.searchParams.delete('page');tags.push('<a data-demo-nav href="'+escape(u.pathname+u.search)+'" aria-label="'+escape(say('remove',{value}))+'">'+escape(key.includes('talla')?say('size_value',{value}):value)+' ×</a>');}
      if(demoState.min||demoState.max){const u=new URL(location.href);u.searchParams.delete('filter.v.price.gte');u.searchParams.delete('filter.v.price.lte');u.searchParams.delete('page');tags.push('<a data-demo-nav href="'+escape(u.pathname+u.search)+'">'+escape(say('price'))+': '+escape(money(demoState.min*100))+' – '+(demoState.max?escape(money(demoState.max*100)):'∞')+' ×</a>');}
      if(tags.length)tags.push('<a class="lnw-clear" data-demo-nav href="'+location.pathname+'">'+escape(say('clear_all'))+'</a>');
      q('[data-active-filters]').innerHTML=tags.join('');
      q('[data-filter-number]').textContent=tags.length?' ('+(demoState.vendors.length+demoState.sizes.length+(demoState.min||demoState.max?1:0))+')':'';
      qa('[data-sort-select]').forEach(s=>s.value=demoState.sort);
      const form=q('[data-filters-form]');
      [...form.elements].forEach(el=>{if(el.type==='checkbox')el.checked=(el.name.includes('vendor')?demoState.vendors:demoState.sizes).includes(el.value);if(el.name==='filter.v.price.gte')el.value=demoState.min||'';if(el.name==='filter.v.price.lte')el.value=demoState.max||'';if(el.name==='sort_by')el.value=demoState.sort;});
      reveal(q('[data-product-grid]'));
    }
    async function nativeNavigate(target,push=true) {
      fetchController?.abort();const request=new AbortController();fetchController=request;
      const url=new URL(target,location.href);if(url.origin!==location.origin)return;
      const zone=q('[data-collection-zone]');zone.setAttribute('aria-busy','true');
      q('[data-navigation-error]').hidden=true;
      const endpoint=new URL(url);endpoint.hash='';endpoint.searchParams.set('section_id',root.dataset.sectionId);
      try {
        const response=await fetch(endpoint,{signal:request.signal,headers:{'Accept':'text/html'}});
        if(!response.ok)throw new Error('section_response');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextZone=doc.querySelector('[data-collection-zone]'),nextFilter=doc.querySelector('[data-modal="filters"]');
        if(!nextZone||!nextFilter)throw new Error('section_missing');
        closeDialogs();
        zone.replaceWith(document.importNode(nextZone,true));
        q('[data-modal="filters"]').replaceWith(document.importNode(nextFilter,true));
        if(push)history.pushState({},'',url.pathname+url.search+url.hash);
        document.title=doc.querySelector('[data-collection-title]')?.dataset.collectionTitle||document.title;
        reveal(q('[data-collection-zone]'));scrollProducts();track('filter_results');
      } catch(error) {
        if(error.name==='AbortError')return;
        const errorBox=q('[data-navigation-error]');errorBox.hidden=false;errorBox.querySelector('a').href=url.pathname+url.search;
      } finally {if(fetchController===request)q('[data-collection-zone]')?.removeAttribute('aria-busy');}
    }
    const navigate = (url,push=true) => {
      if(native)return nativeNavigate(url,push);
      closeDialogs();if(push)history.pushState({},'',url);renderPreview();scrollProducts();track('filter_results');
    };
    on(window,'popstate',()=>native?nativeNavigate(location.href,false):renderPreview());
    function productData(id) {
      if(!native)return allProducts.find(p=>String(p.id)===String(id));
      const script=q('[data-product-json="'+id+'"]');return script?JSON.parse(script.textContent):null;
    }
    async function loadProduct(product, signal) {
      const url=new URL(product.url,location.origin);url.searchParams.set('view','lnw-quick');
      const response=await fetch(url,{signal,headers:{'Accept':'text/html'}});
      if(!response.ok)throw new Error(say('options_error'));
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const data=doc.querySelector('[data-lnw-product-full]');if(!data)throw new Error(say('options_error'));
      return JSON.parse(data.textContent);
    }
    async function openQuick(id) {
      if(adding)return;
      quickController?.abort();quickController=new AbortController();const request=quickController;
      quickProduct=productData(id);if(!quickProduct)return;
      q('[data-quick-title]').textContent=quickProduct.title;
      const photo=q('[data-quick-image]');photo.src=quickProduct.images[0];photo.alt=quickProduct.title;
      q('[data-product-link]').href=quickProduct.url;
      q('[data-quick-delivery]').textContent=quickProduct.delivery||say(quickProduct.kind!=='accessory'&&quickProduct.vendor==='La Nutria'?'ln_delivery':'other_delivery');
      q('[data-modal="quick"] [data-dialog="size"]').hidden=quickProduct.kind==='accessory';
      q('[data-quick-price]').textContent=(quickProduct.priceMax>quickProduct.price?say('from')+' ':'')+money(quickProduct.price)+' '+currency;
      q('[data-quick-status]').textContent=say('loading_options');q('[data-cart-result]').hidden=true;
      q('[data-variant-options]').innerHTML='';q('[data-quick-action]').disabled=true;q('[data-quick-action]').textContent=say('loading_options');
      openDialog('quick');
      try {
        if(native)quickProduct=await loadProduct(quickProduct,request.signal);
        if(request!==quickController)return;
        q('[data-modal="quick"] [data-dialog="size"]').hidden=quickProduct.kind==='accessory';
        selected=quickProduct.options.map((_,i)=>{const values=[...new Set(quickProduct.variants.map(v=>v.options[i]))];return values.length===1?values[0]:null;});
        renderOptions();
      }catch(error){if(error.name!=='AbortError'){q('[data-quick-status]').textContent=say('options_error');q('[data-quick-action]').textContent=say('choose_options');}}
    }
    function selectedVariant(){return quickProduct.variants.find(v=>v.options.every((value,i)=>value===selected[i]));}
    function renderOptions() {
      const holder=q('[data-variant-options]');holder.innerHTML='';
      quickProduct.options.forEach((name,index)=>{
        const values=[...new Set(quickProduct.variants.map(v=>v.options[index]))];
        if(name==='Title'&&values[0]==='Default Title')return;
        const field=document.createElement('fieldset');const legend=document.createElement('legend');legend.textContent=name;field.append(legend);
        const list=document.createElement('div');list.className='lnw-option-values';
        values.forEach(value=>{
          const possible=quickProduct.variants.some(v=>v.options[index]===value&&v.options.every((val,i)=>i===index||!selected[i]||val===selected[i]));
          const button=document.createElement('button');button.type='button';button.className='lnw-option';button.dataset.optionIndex=index;button.dataset.optionValue=value;button.textContent=value;button.disabled=!possible;button.setAttribute('aria-pressed',String(selected[index]===value));list.append(button);
        });field.append(list);holder.append(field);
      });
      const v=selectedVariant(),action=q('[data-quick-action]'),status=q('[data-quick-status]');
      action.disabled=!v||adding;action.dataset.selectedId=v?String(v.id):'';
      if(!v){action.textContent=say('choose_options');status.textContent='';return;}
      q('[data-quick-price]').textContent=money(v.price)+' '+currency;
      const isConsult=quickProduct.consultOnly || !v.buyable;
      action.textContent=say(isConsult?'consult_size':native?'add_to_cart':'continue_store');
      action.dataset.action=isConsult?'consult':native?'add':'product';
      status.textContent=isConsult?say('not_stock'):native?say('stock_ready'):say('preview_check');
      q('[data-product-link]').href=quickProduct.url+'?variant='+v.id;
    }
    async function quickAction(button) {
      const v=selectedVariant();if(!v||adding)return;
      if(button.dataset.action==='consult'){
        const u=new URL(root.dataset.advice);u.searchParams.set('text',say('consult_message',{product:quickProduct.title,variant:v.options.join(' / ')}));location.assign(u.href);return;
      }
      if(button.dataset.action==='product'){location.assign(quickProduct.url+'?variant='+v.id);return;}
      adding=true;button.disabled=true;button.textContent=say('adding');const id=v.id;
      try {
        const latest=await loadProduct(quickProduct);
        const fresh=latest.variants.find(option=>option.id===id);
        if(!fresh?.buyable||latest.consultOnly){quickProduct=latest;adding=false;renderOptions();return;}
        if(fresh.price!==v.price){quickProduct=latest;adding=false;renderOptions();q('[data-quick-status]').textContent=say('price_updated');return;}
        const response=await fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        const data=await response.json();if(!response.ok)throw new Error(data.description||say('add_error'));
        q('[data-quick-status]').textContent=say('added');button.textContent=say('added');
        q('[data-cart-result]').hidden=false;track('add_to_cart_success',{product_id:quickProduct.id,variant_id:id});
      }catch(error){q('[data-quick-status]').textContent=error.message||say('add_error');button.disabled=false;button.textContent=say('add_to_cart');}finally{adding=false;}
    }
    on(root,'click',event=>{
      const target=event.target.closest('a,button,dialog');if(!target)return;
      if(target.matches('dialog')){const r=target.getBoundingClientRect();if(event.target===target&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))target.close();return;}
      if(target.matches('[data-close]')){target.closest('dialog').close();return;}
      if(target.matches('[data-search-result]'))track('search_suggestion_open',{type:target.dataset.searchResult});
      if(target.matches('[data-search-all]'))track('search_all_open');
      if(target.matches('[data-dialog]')){event.preventDefault();openDialog(target.dataset.dialog,target);return;}
      if(target.matches('[data-quick]')){event.preventDefault();openQuick(target.dataset.quick);return;}
      if(target.matches('[data-option-index]')){if(adding)return;selected[Number(target.dataset.optionIndex)]=target.dataset.optionValue;renderOptions();const b=[...q('[data-variant-options]').querySelectorAll('button')].find(b=>b.dataset.optionIndex===target.dataset.optionIndex&&b.dataset.optionValue===target.dataset.optionValue);b?.focus({preventScroll:true});return;}
      if(target.matches('[data-quick-action]')){quickAction(target);return;}
      if(target.matches('[data-native-nav],[data-demo-nav]')&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey){event.preventDefault();navigate(target.href);return;}
      if(target.matches('a[href^="#"]')){const dest=document.getElementById(target.hash.slice(1));if(dest){event.preventDefault();closeDialogs();dest.scrollIntoView({behavior:motion.matches?'instant':'smooth'});dest.setAttribute('tabindex','-1');dest.focus({preventScroll:true});}}
    });
    on(root,'submit',event=>{
      const form=event.target;
      if(form.matches('[data-filters-form]')){
        event.preventDefault();if(!form.reportValidity())return;
        const min=Number(form.querySelector('[name="filter.v.price.gte"]')?.value||0),max=Number(form.querySelector('[name="filter.v.price.lte"]')?.value||0);
        const maxField=form.querySelector('[name="filter.v.price.lte"]');maxField?.setCustomValidity(max&&min>max?say('invalid_range'):'');if(!form.reportValidity())return;
        const url=new URL(form.action,location.href);url.search='';
        if(!native&&demoState.style!=='all')url.searchParams.set('estilo',demoState.style);
        for(const [key,value] of new FormData(form))if(value!=='')url.searchParams.append(key,value);
        url.hash='lnw-products';navigate(url.pathname+url.search+url.hash);
      }
      if(form.matches('[data-measure-form]')){
        event.preventDefault();if(!form.reportValidity())return;
        const cm=Number(form.elements.measure.value);if(!Number.isFinite(cm))return;
        q('[data-measure-result]').textContent=Number.isInteger(cm)?say('fit_whole',{value:cm}):say('fit_between',{lower:Math.floor(cm),upper:Math.ceil(cm)});
        const url=new URL(root.dataset.advice);url.searchParams.set('text',say('measure_message',{value:cm}));q('[data-measure-whatsapp]').href=url.href;
      }
    });
    on(root,'input',event=>{if(event.target.matches('input[type=number]'))event.target.setCustomValidity('');});
    on(root,'change',event=>{
      if(event.target.matches('[data-sort-select]')){const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash='lnw-products';navigate(url.pathname+url.search+url.hash);}
    });
    if(!native)renderPreview();reveal();schedule();
    root.lnwCleanup=()=>{life.abort();clearTimeout(searchTimer);searchController?.abort();fetchController?.abort();quickController?.abort();observer?.disconnect();closeDialogs();document.documentElement.style.overflow=savedOverflow;};
  };
  document.querySelectorAll('[data-ln-western]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ln-western]').forEach(init));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ln-western]').forEach(root=>root.lnwCleanup?.()));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-manolo"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const instances=new WeakMap();
  function init(root){
    if(instances.has(root))return;
    const life=new AbortController(),on=(el,type,fn)=>el?.addEventListener(type,fn,{signal:life.signal});
    const dialog=root.querySelector('[data-lnm-dialog]'),player=root.querySelector('[data-lnm-player]'),video=root.querySelector('[data-lnm-video-template]'),photo=root.querySelector('[data-lnm-photo]');
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    let focusBefore=null,overflowBefore='',frame=0,observer;
    const stop=()=>player?.replaceChildren();
    on(root,'click',event=>{
      const play=event.target.closest('[data-lnm-play]');
      if(play&&dialog&&typeof dialog.showModal==='function'){
        event.preventDefault();if(dialog.open)return;
        focusBefore=play;overflowBefore=document.documentElement.style.overflow;
        dialog.showModal();document.documentElement.style.overflow='hidden';
        player.replaceChildren(video.content.cloneNode(true));
      }
      if(event.target.closest('[data-lnm-close]'))dialog?.close();
    });
    on(dialog,'click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close()}});
    on(dialog,'close',()=>{stop();document.documentElement.style.overflow=overflowBefore;focusBefore?.focus({preventScroll:true})});
    on(window,'pagehide',()=>{if(dialog?.open){dialog.close();document.documentElement.style.overflow=overflowBefore}stop()});
    const reveal=[...root.querySelectorAll('[data-lnm-reveal]')];
    if(!motion.matches&&'IntersectionObserver'in window){
      observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('lnm-pending');observer.unobserve(entry.target)}}),{threshold:.08});
      reveal.forEach((el,index)=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('lnm-pending');el.style.transitionDelay=(el.matches('.lnm-card')?(index%3)*70:0)+'ms';observer.observe(el)}});
    }
    function move(){frame=0;if(!photo||motion.matches)return;const rect=photo.parentElement.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;const progress=Math.max(-1,Math.min(1,(innerHeight/2-rect.top-rect.height/2)/innerHeight));photo.style.transform='translateY('+(-progress*9)+'px) scale(1.04)'}
    function schedule(){if(!frame&&!motion.matches)frame=requestAnimationFrame(move)}
    on(window,'scroll',schedule);on(window,'resize',schedule);schedule();
    on(motion,'change',()=>{if(motion.matches){photo?.style.removeProperty('transform');reveal.forEach(el=>el.classList.remove('lnm-pending'));observer?.disconnect()}else schedule()});
    instances.set(root,()=>{if(dialog?.open){dialog.close();document.documentElement.style.overflow=overflowBefore}stop();life.abort();observer?.disconnect();cancelAnimationFrame(frame);instances.delete(root)});
  }
  const roots=container=>[...(container.matches?.('[data-lnm]')?[container]:[]),...container.querySelectorAll('[data-lnm]')];
  roots(document).forEach(init);
  document.addEventListener('shopify:section:load',event=>roots(event.target).forEach(init));
  document.addEventListener('shopify:section:unload',event=>roots(event.target).forEach(root=>instances.get(root)?.()));
  document.addEventListener('shopify:block:select',event=>{event.target.closest('[data-lnm-reveal]')?.classList.remove('lnm-pending')});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-personalizado"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const P=[["bull-ranch-5x-estilo-walker","Bull Ranch 5x Estilo Walker","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/BullRanch5xEstiloWalker1.png?v=1782935567","western","ranchero","bulldog",13.0,10.5],["bull-ranch-5x-rip-wheeler-1","Bull Ranch 5X Rip Wheeler","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/BullRanch5XRipWheeler_5ab271af-8bcc-4443-81e1-65d50bbf8f77.png?v=1782933540","western","ranchero","roper",12.0,9.5],["bull-ranch-5x-estilo-john-dutton","Bull Ranch 5X Estilo John Dutton","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/BullRanch5XEstiloJohnDutton1.png?v=1782929660","western","ranchero","roper",12.0,10.5],["tombstone-1000x-el-viejon-natural","Tombstone 1000x El Viejon Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000xElViejonNatural1.png?v=1782927691","western","ranchero","oval",14.0,9.0],["tombstone-1000x-estilo-el-fantasma","Tombstone 1000X Estilo El Fantasma","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000xEstiloelFantasma1.png?v=1782927069","artista","norteno","oval",12.0,9.0],["tombstone-1000x-chaparral","Tombstone 1000X Chaparral","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000XChaparral1.png?v=1782926579","western","ranchero","oval",12.0,9.0],["tombstone-1000x-estilo-los-dos-carnales","Tombstone 1000x Estilo Los Dos Carnales","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000xEstiloLosDosCarnales1.png?v=1782924368","artista","norteno","oval",13.0,9.0],["tombstone-1000x-estilo-panter-belico","Tombstone 1000X Estilo Panter Bélico","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000xEstiloPanterBelico1.png?v=1782922804","artista","norteno","puntal",12.0,9.0],["tombstone-1000x-estilo-sinaloa","Tombstone 1000X Estilo Sinaloa","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/Tombstone1000xEstiloSinaloa01_bf159779-2309-4151-bf17-e0ea722e0edd.png?v=1782921956","artista","norteno","oval",12.0,9.0],["tombstone-denver-italy","Tombstone Denver Italy","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/TombstoneDenverItaly1.png?v=1782837759","western","ranchero","oval",12.0,9.5],["tombstone-sinaloa-italy","Tombstone Sinaloa Italy","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/TombstoneSinaloaItaly01.png?v=1782831871","artista","norteno","oval",12.0,9.0],["tombstone-roper-crown-italy","Tombstone Roper Crown Italy","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/TombstoneOpenCrownItaly01_1d4f86a1-7808-49fa-94a6-f0b291a781de.png?v=1782829708","western","ranchero","plana",13.0,10.5],["tombstone-open-crown-italy","Tombstone Open Crown Italy","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/TombstoneOpenCrownItaly01.png?v=1782829354","western","ranchero","plana",13.0,10.5],["tombstone-este-oeste-italy","Tombstone Este-Oeste Italy","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/TombstoneEste-OesteItaly-1.png?v=1782828939","western","ranchero","roper",12.0,10.5],["la-nutria-los-dos-carnales","La Nutria Los Dos Carnales","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutriaDosCarnales7.png?v=1781647614","artista","norteno","oval",13.0,9.0],["la-nutria-estilo-eduin-caz","La Nutria Estilo Eduin Caz","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_11_59_55_a.m._4.png?v=1782237622","artista","norteno","oval",13.0,9.0],["la-nutria-eden-munoz","La Nutria Eden Muñoz","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutriaEdenMunoz1.png?v=1781636584","artista","norteno","puntal",12.0,10.0],["la-nutria-chalino-sanchez","La Nutria Chalino Sánchez","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_07_41_51_a.m._4.png?v=1782222125","artista","norteno","oval",12.0,9.0],["la-nutria-4x-ariel-camacho","La Nutria Ariel Camacho","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/93d8af07-c510-4436-8221-d4215c72ffb2.png?v=1782150603","artista","norteno","puntal",13.0,9.0],["la-nutria-4x-joan-sebastian","La Nutria Joan Sebastian","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_08_51_12_a.m._1.png?v=1782226296","artista","norteno","puntal",12.0,10.5],["la-nutria-4x-estilo-julion-alvarez","La Nutria Estilo Julión Álvarez","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xEstiloJulionAlvarez1.png?v=1781281028","artista","norteno","roper",13.0,9.0],["la-nutria-4x-estilo-alfredo-olivas","La Nutria Estilo Alfredo Olivas","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xEstiloAlfredoOlivas1.png?v=1781279101","artista","norteno","oval",13.0,9.0],["la-nutria-4x-estilo-pedro-navajas","La Nutria Estilo Pedro Navajas","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xEstiloPedroNavajas1.png?v=1781278081","urbano","catrin","plana",12.0,9.0],["la-nutria-4x-pedro-infante-negro-gavilanes","La Nutria Pedro Infante (Gavilanes)","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_09_09_17_a.m..png?v=1782227371","urbano","catrin","roper",12,10],["la-nutria-4x-pedro-infante","La Nutria Pedro Infante","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_08_57_03_a.m._1.png?v=1782226635","urbano","catrin","roper",12,10],["la-nutria-4x-walker","La Nutria Walker","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_09_26_56_a.m._3.png?v=1782228459","western","ranchero","bulldog",13.0,10.5],["bull-ranch-5x-estilo-walker-silverbelly","Bull Ranch 5x Estilo Walker Silverbelly","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/BullRanch5xEstiloWalkerSilverbelly1.png?v=1781216605","western","ranchero","bulldog",13.0,10.5],["bull-ranch-5x-estilo-john-dutton-silverbelly","Bull Ranch 5x Estilo John Dutton Silverbelly","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/BullRanch5xEstiloJohnDuttonSilverbelly3.png?v=1781214993","western","ranchero","roper",12.0,10.5],["la-nutria-4x-estilo-kayce-dutton","La Nutria Estilo Kayce Dutton","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xEstiloKayceDutton4.png?v=1781214508","western","ranchero","roper",12.0,10.5],["la-nutria-4x-indiana-jones","La Nutria Indiana Jones","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xIndianaJones1.png?v=1781195864","urbano","casual","oval",12.0,8.0],["la-nutria-4x-doc-holliday","La Nutria Doc Holliday","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xDocHolliday1_bc7db033-993e-491f-8298-43981bfc3f77.png?v=1781194879","urbano","pistolero","oval",12.0,10.0],["la-nutria-4x-clint-eastwood","La Nutria Clint Eastwood","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xClintEastwood18.png?v=1781192647","urbano","pistolero","oval",12.0,9.5],["la-nutria-4x-django","La Nutria Django","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xDjango1.png?v=1781130799","urbano","pistolero","oval",11.0,9.5],["la-nutria-4x-victorias-love","La Nutria Victorias Love","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutria4xVictoriasLove1.png?v=1781043230","ella","distintivo","oval",10.0,9.0],["san-palmo-victorias-love-natural","San Palmo Victorias Love Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_04_02_51_p.m..png?v=1782252187","ella","distintivo","oval",10.0,9.0],["la-nutria-4x-estilo-beth-dutton","La Nutria Estilo Beth Dutton","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_07_46_50_a.m._2.png?v=1782222438","ella","distintivo","plana",12.0,8.0],["la-nutria-silverbelly","La Nutria Barbie","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_22_jun_2026_01_54_21_p.m._1.png?v=1782158079","ella","distintivo","roper",12.0,10.5],["san-palmo-tlatoani-black-and-white","San Palmo Tlatoani Black and White","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_55_00_p.m..png?v=1782251709","urbano","catrin","oval",11.0,9.0],["san-palmo-centinela-natural","San Palmo Centinela Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_39_58_p.m..png?v=1782250814","western","ranchero","roper",12.0,10.5],["la-nutria-marlboro","La Nutria Marlboro","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/LaNutriaMalboro1.png?v=1781030901","western","ranchero","oval",12.0,10.5],["la-nutria-gran-jefe-crin","La Nutria Gran Jefe Crin","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_08_39_06_a.m._4.png?v=1782225570","western","ranchero","roper",12.0,10.5],["la-nutria-robavacas","La Nutria Robavacas","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_09_17_49_a.m._1.png?v=1782227881","western","ranchero","puntal",13.0,11.0],["la-nutria-4x-open-road","La Nutria Open Road","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_01_28_27_p.m._4.png?v=1782242923","urbano","casual","oval",11.0,8.0],["san-palmo-robavacas-natural","San Palmo Robavacas Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_52_54_p.m..png?v=1782251583","western","ranchero","puntal",13.0,11.0],["san-palmo-gran-jefe-natural","San Palmo Gran Jefe Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_45_49_p.m..png?v=1782251197","western","ranchero","roper",12.0,10.5],["san-palmo-americano-natural","San Palmo Americano Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_35_29_p.m..png?v=1782250542","western","ranchero","oval",12.0,10.5],["san-palmo-toro-natural","San Palmo Toro Natural","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_03_58_59_p.m..png?v=1782251949","western","ranchero","roper",12.0,10.5],["la-nutria-4x-estilo-rancher-negro","La Nutria Estilo Rancher","https://cdn.shopify.com/s/files/1/0669/0337/5941/files/ChatGPT_Image_23_jun_2026_08_31_39_a.m._4.png?v=1782225297","western","ranchero","oval",13.0,10.5]];

  const PI = {redonda:"oval",ovalada:"roper",cuadrada:"roper",alargada:"oval",corazon:"puntal"};
  const FL = {delgada:["Falda media","8.5 - 9.5 cm",9],estandar:["Falda media","10 cm aprox.",10],atletica:["Falda amplia","10 - 10.5 cm",10.5],robusta:["Falda ancha","10.5 - 11.5 cm",11]};
  const CO = {bajo:["Copa alta","12 - 13 cm",13],medio:["Copa estándar","11 - 12 cm",12],alto:["Copa media","10 - 11 cm",11],muyalto:["Copa baja/media","10 - 11 cm",11]};
  const instances=new WeakMap();
  function init(root){
    if(instances.has(root))return;
    const life=new AbortController();
    const on=(node,event,callback)=>node.addEventListener(event,callback,{signal:life.signal});
    const q=selector=>root.querySelector(selector);
    const hero=q('.lnq-hero'),quiz=q('.lnq-quiz'),contact=q('.lnq-contact'),result=q('.lnq-result');
    const steps=[...root.querySelectorAll('.lnq-step')],form=q('.lnq-lead');
    const start=q('.lnq-start'),next=q('.lnq-next'),progress=q('.lnq-meter');
    const nameInput=form.elements.namedItem('nombre'),phoneInput=form.elements.namedItem('whatsapp');
    const submit=form.querySelector('[type=submit]'),error=q('.lnq-error');
    const messages=JSON.parse(q('[data-lnq-messages]').textContent);
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    let st={},step=1,sending=false,selection=null;
    const pending=new Set();
    const cap=value=>String(value||'').charAt(0).toUpperCase()+String(value||'').slice(1);
    const announce=(key,values={})=>Object.entries(values).reduce((text,[name,value])=>text.replaceAll('{'+name+'}',String(value)),messages[key]);
    function show(panel,focus){
      [hero,quiz,contact,result].forEach(node=>{node.hidden=node!==panel});
      if(focus){
        focus.focus({preventScroll:true});
        root.scrollIntoView({behavior:motion.matches?'auto':'smooth',block:'start'});
      }
    }
    function updateOptions(){
      steps.forEach(panel=>panel.querySelectorAll('.lnq-opt').forEach(button=>{
        button.setAttribute('aria-pressed',String(st[button.dataset.key]===button.dataset.value));
      }));
      next.disabled=!st[steps[step-1].dataset.key];
    }
    function go(number){
      step=Math.max(1,Math.min(number,steps.length));
      steps.forEach((panel,index)=>{panel.hidden=index!==step-1});
      q('.lnq-pt').textContent=announce('progress',{current:step,total:steps.length});
      progress.setAttribute('aria-valuenow',String(step));
      progress.setAttribute('aria-valuetext',q('.lnq-pt').textContent);
      q('.lnq-bar').style.width=step/steps.length*100+'%';
      next.querySelector('[data-lnq-next-label]').textContent=messages[step===steps.length?'finish':'next'];
      updateOptions();
      show(quiz,steps[step-1].querySelector('h2'));
    }
    function clearErrors(){
      error.hidden=true;error.textContent='';
      nameInput.removeAttribute('aria-invalid');phoneInput.removeAttribute('aria-invalid');
    }
    function invalid(input,message){
      clearErrors();input.setAttribute('aria-invalid','true');error.hidden=false;error.textContent=message;input.focus();
    }
    function prepareResult(){
      const punta=PI[st.face]||'roper',falda=FL[st.body]||FL.estandar,copa=CO[st.height]||CO.medio;
      selection={punta,falda,copa,items:best(punta,falda[2],copa[2]).slice(0,4)};
      clearErrors();show(contact,contact.querySelector('h2'));
    }
    function sendLead(payload){
      if(root.dataset.designMode==='true'||!root.dataset.leadEndpoint)return Promise.resolve();
      let url;
      try{url=new URL(root.dataset.leadEndpoint);if(url.protocol!=='https:')return Promise.resolve()}catch{return Promise.resolve()}
      Object.entries(payload).forEach(([key,value])=>url.searchParams.set(key,value));
      url.searchParams.set('cache',String(Date.now()));
      return new Promise(resolve=>{
        const beacon=new Image();let timer;
        const finish=()=>{clearTimeout(timer);beacon.onload=null;beacon.onerror=null;pending.delete(finish);resolve()};
        pending.add(finish);beacon.onload=finish;beacon.onerror=finish;beacon.referrerPolicy='no-referrer';
        timer=setTimeout(finish,900);beacon.src=url.href;
      });
    }
    function renderResult(){
      const {punta,items}=selection;
      q('[data-lnq-punta]').textContent=cap(punta);
      q('[data-lnq-falda]').textContent=messages['brim_'+st.body];
      q('[data-lnq-falda-range]').textContent=messages['brim_range_'+st.body];
      q('[data-lnq-copa]').textContent=messages['crown_'+st.height];
      q('[data-lnq-copa-range]').textContent=messages['crown_range_'+st.height];
      const products=q('.lnq-products'),template=q('[data-lnq-card-template]');
      products.replaceChildren();
      items.forEach((product,index)=>{
        const card=template.content.firstElementChild.cloneNode(true);
        const prefix=(root.dataset.rootUrl||'/').replace(/\/?$/,'/');
        card.href=prefix+'products/'+encodeURIComponent(product[0]);
        const photo=card.querySelector('img'),imageUrl=new URL(product[2]);imageUrl.searchParams.set('width','600');photo.src=imageUrl.href;photo.alt=product[1];
        card.querySelector('h3').textContent=product[1];
        card.querySelector('.lnq-card-badge').textContent=messages[index?'recommended':'best'];
        card.querySelector('.lnq-card-family').textContent=messages['family_'+product[3]];
        card.querySelector('.lnq-card-specs').textContent=announce('dimensions',{crown:product[6],brim:product[7]});
        products.append(card);
      });
      show(result,result.querySelector('h2'));
    }
    function reset(){
      st={};step=1;selection=null;sending=false;form.reset();clearErrors();
      submit.disabled=false;submit.textContent=messages.submit;form.removeAttribute('aria-busy');
      updateOptions();q('.lnq-products').replaceChildren();show(hero,start);
    }
    on(start,'click',()=>go(1));
    on(quiz,'click',event=>{
      const option=event.target.closest('.lnq-opt');
      if(option&&option.closest('.lnq-step')===steps[step-1]){
        st[option.dataset.key]=option.dataset.value;updateOptions();
      }
    });
    on(next,'click',()=>{if(!next.disabled){if(step<steps.length)go(step+1);else prepareResult()}});
    on(q('.lnq-back'),'click',()=>{if(step>1)go(step-1);else show(hero,start)});
    on(q('[data-lnq-edit]'),'click',()=>{if(!sending)go(steps.length)});
    on(q('.lnq-reset'),'click',reset);
    on(nameInput,'input',clearErrors);
    on(phoneInput,'input',()=>{phoneInput.value=phoneInput.value.replace(/\D/g,'').slice(0,15);clearErrors()});
    on(form,'submit',async event=>{
      event.preventDefault();
      if(sending||!selection||contact.hidden)return;
      const nombre=nameInput.value.trim(),whatsapp=phoneInput.value.replace(/\D/g,'');
      if(!nombre)return invalid(nameInput,messages.name_error);
      if(whatsapp.length<10||whatsapp.length>15)return invalid(phoneInput,messages.phone_error);
      clearErrors();sending=true;submit.disabled=true;submit.textContent=messages.preparing;form.setAttribute('aria-busy','true');
      q('[data-lnq-edit]').disabled=true;
      const {punta,falda,copa,items}=selection;
      const payload={nombre,whatsapp,estilo:st.style||'',proyeccion:st.projection||'',rostro:st.face||'',estatura:st.height||'',complexion:st.body||'',lentes:st.glasses||'',punta:cap(punta),falda:falda[0]+' · '+falda[1],copa:copa[0]+' · '+copa[1],producto:items[0]?items[0][1]:''};
      await sendLead(payload);
      if(life.signal.aborted||!root.isConnected)return;
      sending=false;submit.disabled=false;submit.textContent=messages.submit;form.removeAttribute('aria-busy');q('[data-lnq-edit]').disabled=false;
      renderResult();
    });
        function best(pu, fa, co){
      function rb(x){
        let str=(st.style||"")+(st.projection||"")+(st.face||"")+(st.height||"")+(st.body||"")+(st.glasses||"")+x[0],n=0;
        for(let i=0;i<str.length;i++) n=(n*31+str.charCodeAt(i))%997;
        return n/1000;
      }
      return P
        .map(function(x){ return [x, score(x, pu, fa, co)+rb(x)]; })
        .sort(function(a,b){ return b[1] - a[1]; })
        .map(function(x){ return x[0]; });
    }

    function score(x, pu, fa, co){
      let sc = 5;
      if(st.style === "vaquero") sc += x[3] === "western" ? 55 : (x[3] === "artista" ? 24 : 10);
      if(st.style === "urbano") sc += x[3] === "urbano" ? 55 : (x[4] === "catrin" ? 38 : 8);
      if(st.style === "escenario") sc += x[3] === "artista" ? 60 : (x[3] === "western" ? 20 : 8);
      if(st.style === "elegante") sc += (x[4] === "catrin" || x[3] === "urbano") ? 50 : (x[4] === "pistolero" ? 34 : 8);
      if(st.style === "distintivo") sc += x[3] === "ella" ? 60 : (x[4] === "pistolero" ? 20 : 8);

      if(x[5] === pu) sc += 26;
      else if((pu === "oval" && (x[5] === "plana" || x[5] === "roper")) || (pu === "roper" && x[5] === "oval")) sc += 12;
      else if(pu === "puntal" && (x[5] === "roper" || x[5] === "bulldog")) sc += 10;

      if(Math.abs((x[7] || fa) - fa) <= .5) sc += 18;
      else if(Math.abs((x[7] || fa) - fa) <= 1.5) sc += 10;

      if(Math.abs((x[6] || co) - co) <= .5) sc += 18;
      else if(Math.abs((x[6] || co) - co) <= 1.5) sc += 10;

      if(st.projection === "presencia" && x[7] >= 10.5) sc += 14;
      if(st.projection === "elegancia" && (x[4] === "catrin" || x[3] === "urbano")) sc += 14;
      if(st.projection === "caracter" && (x[4] === "pistolero" || x[3] === "artista" || x[5] === "puntal")) sc += 14;
      if(st.projection === "versatilidad" && (x[3] === "urbano" || x[5] === "oval")) sc += 12;
      if(st.projection === "sobriedad" && (x[4] === "ranchero" || x[3] === "western")) sc += 12;
      if(st.glasses === "si" && x[7] >= 9) sc += 6;

      return sc;
    }
    start.hidden=false;submit.disabled=false;submit.textContent=messages.submit;form.removeAttribute('aria-busy');q('[data-lnq-edit]').disabled=false;form.reset();clearErrors();show(hero);steps.forEach(panel=>{panel.hidden=true});updateOptions();
    instances.set(root,()=>{life.abort();pending.forEach(finish=>finish());form.reset();q('.lnq-products').replaceChildren();instances.delete(root)});
  }
  function scan(scope){if(scope.matches?.('[data-lnq]'))init(scope);scope.querySelectorAll?.('[data-lnq]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    if(event.target.matches?.('[data-lnq]'))instances.get(event.target)?.();
    event.target.querySelectorAll?.('[data-lnq]').forEach(root=>instances.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-product"]) return;
  try {
    
(()=>{
  function initialize(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];
    let product=JSON.parse(q('[data-pdp-json]').textContent),selected=[],galleryIndex=0,adding=false,quantity=1;
    const gallery=qa('[data-pdp-thumb]').map(button=>({id:button.dataset.mediaId,type:button.dataset.mediaType,aspect:Number(button.dataset.mediaAspect)||1,url:button.dataset.mediaUrl,alt:button.dataset.mediaAlt}));
    let activePlayer=null,activePlayerId=null,activeFrame=null,activePlayButton=null,playerController=null,playerSizeObserver=null;
    const native=root.dataset.mode==='native',currency=root.dataset.currency||'MXN',country=root.dataset.country||'MX';
    const messages=JSON.parse(q('[data-pdp-messages]')?.textContent||'{}');
    const say=(key,fallback,values={})=>Object.entries(values).reduce((text,[k,v])=>text.replaceAll('{'+k+'}',String(v)),messages[key]||fallback);
    const controller=new AbortController(),on=(el,type,fn,options={})=>el?.addEventListener(type,fn,{...options,signal:controller.signal});

    const journey=q('[data-pdp-journey]');
    const journeyEnabled=journey&&product.family==='nutria'&&journey.dataset.enabled!=='false';
    function refreshJourney(){
      if(!journeyEnabled)return;
      const field=name=>journey.querySelector('[data-journey-'+name+']');
      const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(part=>[part.type,part.value]));
      const today=new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)));
      const iso=date=>date.toISOString().slice(0,10);
      const closed=new Set((journey.dataset.closedDates||'').match(/\b\d{4}-\d{2}-\d{2}\b/g)||[]);
      const working=date=>![0,6].includes(date.getUTCDay())&&!closed.has(iso(date));
      const business=(date,count)=>{const result=new Date(date);let guard=0;while(count>0&&guard<800){result.setUTCDate(result.getUTCDate()+1);if(working(result))count--;guard++;}return result;};
      const days=(value,fallback)=>{const parsed=Number(value);return Number.isFinite(parsed)?Math.max(0,Math.min(90,Math.trunc(parsed))):fallback;};
      const prepMin=Math.max(1,days(journey.dataset.prepMin,8)),prepMax=Math.max(prepMin,days(journey.dataset.prepMax,10));
      const transitMin=days(journey.dataset.transitMin,0),transitMax=Math.max(transitMin,days(journey.dataset.transitMax,0));
      const dispatchMin=business(today,prepMin),dispatchMax=business(today,prepMax);
      const formatter=new Intl.DateTimeFormat(root.dataset.locale||'es-MX',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'});
      const format=date=>formatter.format(date);
      const shortFormatter=new Intl.DateTimeFormat(root.dataset.locale||'es-MX',{day:'numeric',month:'short',timeZone:'UTC'});
      const shortFormat=date=>shortFormatter.format(date);
      const shortRange=(first,last)=>first.getUTCFullYear()!==last.getUTCFullYear()?range(first,last):iso(first)===iso(last)?shortFormat(first):typeof shortFormatter.formatRange==='function'?shortFormatter.formatRange(first,last):shortFormat(first)+' – '+shortFormat(last);
      const range=(first,last)=>iso(first)===iso(last)?format(first):typeof formatter.formatRange==='function'?formatter.formatRange(first,last):format(first)+' – '+format(last);
      const hasTransit=country==='MX'&&transitMin>0;
      field('order').textContent=shortFormat(today);
      field('start').textContent=shortFormat(business(today,1));
      field('dispatch').textContent=shortRange(dispatchMin,dispatchMax);
      field('arrival').textContent=hasTransit?shortRange(business(dispatchMin,transitMin),business(dispatchMax,transitMax)):journey.dataset.destinationLabel;
      field('estimate-label').textContent=hasTransit?journey.dataset.arrivalLabel:journey.dataset.dispatchLabel;
      field('estimate').textContent=hasTransit?range(business(dispatchMin,transitMin),business(dispatchMax,transitMax)):range(dispatchMin,dispatchMax);
      field('carrier-note').hidden=hasTransit;
    }
    refreshJourney();
    on(window,'pageshow',refreshJourney);
    on(document,'visibilitychange',()=>{if(!document.hidden)refreshJourney()});

    const motion=matchMedia('(prefers-reduced-motion:reduce)');
    const money=cents=>new Intl.NumberFormat(root.dataset.locale==='es'&&country==='MX'?'es-MX':root.dataset.locale||'es-MX',{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);
    const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const normalize=s=>String(s).toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    const kind=name=>/color/i.test(name)?'color':/material|calidad/i.test(name)?'material':/talla|size/i.test(name)?'size':'other';
    const fullSizeLabel=value=>/uni[\s-]*talla|one[\s-]*size|talla[\s-]*(?:unica|universal)/.test(normalize(value))||String(value).length>8;
    const priorities={color:0,material:1,other:2,size:3};
    const optionOrder=product.options.map((name,index)=>({name,index,kind:kind(name)})).sort((a,b)=>priorities[a.kind]-priorities[b.kind]);
    const track=(action,extra={})=>{const event={event:'ln_product_interaction',action,product_id:product.id,...extra};root.dispatchEvent(new CustomEvent('ln:product',{detail:event,bubbles:true}));if(Array.isArray(window.dataLayer))window.dataLayer.push(event)};
  const arrowPattern=/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?/gu;
  const arrowDirection=char=>({ '←':'left','‹':'left','«':'left','❮':'left','↑':'up','↓':'down','↗':'up-right','↘':'down-right','↖':'up-left','↙':'down-left' }[char]||'right');
  const arrowPaths={right:'M4 12h15m-6-6 6 6-6 6',left:'M20 12H5m6-6-6 6 6 6',up:'M12 20V5m-6 6 6-6 6 6',down:'M12 4v15m-6-6 6 6 6-6','up-right':'M5 19 19 5M7 5h12v12','down-right':'M5 5l14 14M7 19h12V7','up-left':'M19 19 5 5m0 12V5h12','down-left':'M19 5 5 19m0-12v12h12'};
  const makeArrow=character=>{
   const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
   for(const [name,value] of Object.entries({class:'lnp-arrow lnp-text-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
   path.setAttribute('d',arrowPaths[arrowDirection(character[0])]);path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;
  };
  const normalizeMenuArrows=()=>{
   const menu=q('[data-modal="menu"]');if(!menu)return;
   menu.querySelectorAll('svg').forEach(svg=>{
    const paths=[...svg.querySelectorAll('path')];
    if(paths.length!==1||!/^(?:m146-6666|m10666-66|m412h15m-6-666-66|m69666-6)$/i.test((paths[0].getAttribute('d')||'').replace(/[\s,]/g,'')))return;
    svg.classList.add('lnp-arrow');
    for(const [name,value] of Object.entries({fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round'}))svg.setAttribute(name,value);
    paths[0].setAttribute('fill','none');paths[0].setAttribute('stroke','currentColor');
   });
   const walker=document.createTreeWalker(menu,NodeFilter.SHOW_TEXT),nodes=[];let node;
   while(node=walker.nextNode()){const parent=node.parentElement;if(parent?.closest('a,button,summary')&&!parent.closest('svg,script,style')&&/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮]/u.test(node.data))nodes.push(node)}
   nodes.forEach(text=>{const fragment=document.createDocumentFragment();let position=0;for(const match of text.data.matchAll(arrowPattern)){fragment.append(document.createTextNode(text.data.slice(position,match.index)),makeArrow(match[0]));position=match.index+match[0].length}fragment.append(document.createTextNode(text.data.slice(position)));text.replaceWith(fragment)});
   menu.querySelectorAll('a,button,summary,a span,button span,summary span').forEach(element=>{
    if(element.closest('svg'))return;
    for(const side of ['before','after']){
     if(element.hasAttribute('data-ln-arrow-'+side))continue;
     let content='';try{content=getComputedStyle(element,'::'+side).content||''}catch{}
     const text=content.replace(/^["']|["']$/g,'').trim();
     if(!/^[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?$/u.test(text))continue;
     element.setAttribute('data-ln-arrow-'+side,'');const svg=makeArrow(text);if(side==='before')element.prepend(svg);else element.append(svg);
    }
   });
  };
    on(q('[data-modal="menu"]'),'toggle',normalizeMenuArrows,{capture:true});
    let lastFocus=null,oldOverflow='';
    const dialogOpeners=new WeakMap(),skipDialogReturn=new WeakSet();
    const searchDialog=q('[data-modal="search"]'),searchInput=searchDialog?.querySelector('input[name="q"]'),searchViewport=window.visualViewport;
    const syncSearchTrigger=()=>qa('[data-dialog="search"][aria-expanded]').forEach(trigger=>trigger.setAttribute('aria-expanded',String(Boolean(searchDialog?.open))));
    const updateSearchViewport=()=>{
      if(!searchDialog)return;
      const height=searchViewport?.height||window.innerHeight,width=searchViewport?.width||window.innerWidth;
      searchDialog.style.setProperty('--lnw-visual-height',height+'px');
      searchDialog.style.setProperty('--lnw-visual-width',width+'px');
      searchDialog.style.setProperty('--lnw-visual-top',Math.max(0,searchViewport?.offsetTop||0)+'px');
      searchDialog.style.setProperty('--lnw-visual-left',Math.max(0,searchViewport?.offsetLeft||0)+'px');
      searchDialog.classList.toggle('is-short',height<300);
    };
    on(searchViewport,'resize',updateSearchViewport,{passive:true});
    on(searchViewport,'scroll',updateSearchViewport,{passive:true});
    on(window,'resize',updateSearchViewport,{passive:true});
    updateSearchViewport();
    function openDialog(name,opener=document.activeElement){
      const dialog=q('[data-modal="'+name+'"]');if(!dialog||dialog.open)return;
      pauseMedia();
      const parent=opener?.closest('dialog'),focus=parent?(dialogOpeners.get(parent)||lastFocus):opener;
      const opened=qa('dialog[open]');
      if(!opened.length)oldOverflow=document.documentElement.style.overflow;
      opened.forEach(d=>{skipDialogReturn.add(d);d.close()});
      lastFocus=focus;dialogOpeners.set(dialog,focus);document.documentElement.style.overflow='hidden';
      if(dialog===searchDialog)updateSearchViewport();
      dialog.showModal();if(name==='menu')normalizeMenuArrows();syncSearchTrigger();syncPlayer();
      if(dialog===searchDialog){searchInput?.focus({preventScroll:true});updateSearchViewport()}
      if(name==='zoom')playCurrentVideo();track('open_'+name);
    }
    on(root,'close',event=>{
      if(!event.target.matches('dialog'))return;
      syncSearchTrigger();
      const skip=skipDialogReturn.delete(event.target);
      if(q('dialog[open]'))return;
      pauseMedia();syncPlayer();document.documentElement.style.overflow=oldOverflow;
      if(!skip)dialogOpeners.get(event.target)?.focus({preventScroll:true});
    },{capture:true});
    on(searchInput?.form,'submit',event=>{
      searchInput.value=searchInput.value.trim();
      if(!searchInput.value){event.preventDefault();searchInput.focus({preventScroll:true});return}
      track('search_submit');
    });
    const ruler='<svg class="lnw-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="18" height="10"/><path d="M7 7v4m5-4v6m5-6v4"/></svg>';
    function upstream(index){const position=optionOrder.findIndex(o=>o.index===index);return optionOrder.slice(0,position).map(o=>o.index)}
    function possible(index,value){const before=upstream(index);return product.variants.filter(v=>v.options[index]===value&&before.every(i=>!selected[i]||v.options[i]===selected[i]))}
    function reconcile(){for(const {index} of optionOrder){const values=[...new Set(product.variants.map(v=>v.options[index]))].filter(value=>possible(index,value).length);if(selected[index]&&!values.includes(selected[index]))selected[index]=null;if(values.length===1)selected[index]=values[0]}}
    const matches=()=>product.variants.filter(v=>v.options.every((value,i)=>!selected[i]||value===selected[i]));
    const current=()=>selected.every(Boolean)?product.variants.find(v=>v.options.every((value,i)=>value===selected[i])):null;
    const colors={negro:'#171614',black:'#171614',chocolate:'#4a2c1e','silver belly':'#c7bba7',silverbelly:'#c7bba7',perla:'#d7d8db',blanco:'#f4f4ee',white:'#f4f4ee',natural:'#d9c8a7',cafe:'#60412d',gris:'#888581',beige:'#d6c6aa'};
    function renderOptions(){
      const holder=q('[data-pdp-options]');holder.innerHTML='';
      for(const {name,index,kind:k} of optionOrder){
        const values=[...new Set(product.variants.map(v=>v.options[index]))];if(name==='Title'&&values[0]==='Default Title')continue;
        const field=document.createElement('fieldset');field.className='lnp-option';field.dataset.kind=k;field.dataset.optionGroup=index;
        const chosen=selected[index]||say('select','Selecciona');
        field.innerHTML='<legend>'+escape(name)+' <span>'+escape(chosen)+'</span>'+(k==='size'?'<button type="button" data-pdp-guide>'+ruler+say('size_guide','Guía de talla')+'</button>':'')+'</legend>';
        const list=document.createElement('div');list.className='lnp-option-values '+(k==='color'?'lnp-colors':k==='material'?'lnp-materials':'');
        for(const value of values){
          const variants=possible(index,value);const canBuy=variants.some(v=>native?v.buyable:v.available);
          const button=document.createElement('button');button.type='button';button.className='lnp-choice'+(variants.length&&!canBuy?' is-sold-out':'');button.dataset.pdpOption=index;button.dataset.pdpValue=value;button.disabled=!variants.length;button.setAttribute('aria-pressed',String(selected[index]===value));
          if(k==='size'&&fullSizeLabel(value))button.classList.add('lnp-choice--full-label');
          button.setAttribute('aria-label',value+(variants.length&&!canBuy?' · '+say('consult_availability','Consultar disponibilidad'):''));
          if(k==='color'){
            const image=variants.find(v=>v.image)?.image;
            button.innerHTML=(image?'<img class="lnp-color-image" src="'+escape(image)+'" width="49" height="49" alt="" loading="lazy">':'<span class="lnp-color-dot" style="--swatch:'+escape(colors[normalize(value)]||'#d6c6aa')+'"></span>')+'<span>'+escape(value)+'</span>';
          }else if(k==='material'){
            const quality=value.match(/\b\d+x\b/i)?.[0]||'';const label=quality?value.replace(quality,'').trim():value;const price=variants.length?Math.min(...variants.map(v=>v.price)):null;
            button.innerHTML='<strong>'+escape(quality.toUpperCase())+'</strong><span>'+escape(label)+'</span>'+(price!==null?'<small>'+escape(money(price))+'</small>':'');
          }else button.textContent=value;
          list.append(button);
        }
        field.append(list);holder.append(field);
      }

    }
    function fitCurrentPlayer(){
      if(!activeFrame||!activePlayer)return;
      const holder=activeFrame.parentElement;if(!holder||holder.hidden)return;
      const box=holder.getBoundingClientRect(),styles=getComputedStyle(holder);
      const width=box.width-(parseFloat(styles.paddingLeft)||0)-(parseFloat(styles.paddingRight)||0);
      const height=box.height-(parseFloat(styles.paddingTop)||0)-(parseFloat(styles.paddingBottom)||0);
      if(width<=0||height<=0)return;
      const item=gallery[galleryIndex];
      const actual=activePlayer.tagName==='VIDEO'&&activePlayer.videoWidth&&activePlayer.videoHeight?activePlayer.videoWidth/activePlayer.videoHeight:item?.aspect;
      const ratio=Number.isFinite(actual)&&actual>0?actual:1;
      const fittedWidth=Math.min(width,height*ratio),fittedHeight=fittedWidth/ratio;
      activeFrame.style.width=Math.floor(fittedWidth*100)/100+'px';
      activeFrame.style.height=Math.floor(fittedHeight*100)/100+'px';
    }
    function enableVideoAudio(video){
      video.removeAttribute('muted');video.defaultMuted=false;video.muted=false;video.volume=1;
    }
    function setPlayLabel(label){
      if(activePlayButton){activePlayButton.querySelector('span').textContent=label;activePlayButton.setAttribute('aria-label',label)}
    }
    function pauseMedia(){
      if(activePlayer?.tagName==='VIDEO')activePlayer.pause();
      if(activePlayer?.tagName==='IFRAME')releasePlayer();
    }
    function releasePlayer(){
      playerSizeObserver?.disconnect();playerSizeObserver=null;
      playerController?.abort();playerController=null;
      if(activePlayer?.tagName==='VIDEO')activePlayer.pause();
      activeFrame?.remove();activePlayer?.remove();activePlayer=null;activePlayerId=null;activeFrame=null;activePlayButton=null;
      qa('[data-pdp-player],[data-pdp-zoom-player]').forEach(holder=>holder.hidden=true);
    }
    function playCurrentVideo(){
      const video=activePlayer;if(video?.tagName!=='VIDEO'||!video.isConnected)return;
      const label=root.dataset.videoLabel||say('play_video','Reproducir video');
      setPlayLabel(label);
      enableVideoAudio(video);
      if(video.error)video.load();
      const failed=error=>{if(activePlayer!==video||error?.name==='AbortError')return;if(activePlayButton)activePlayButton.hidden=false;setPlayLabel(error?.name==='NotAllowedError'?label:say('video_retry','No se pudo iniciar. Toca para reintentar.'))};
      try{const result=video.play();if(result?.catch)result.catch(failed)}catch(error){failed(error)}
    }
    function syncPlayer(){
      const item=gallery[galleryIndex],isVideo=item&&(item.type==='video'||item.type==='external_video');
      const holders=qa('[data-pdp-player],[data-pdp-zoom-player]');
      if(!isVideo){releasePlayer();return}
      const holder=q(q('[data-modal="zoom"]')?.open?'[data-pdp-zoom-player]':'[data-pdp-player]');
      if(!holder)return;
      let created=false;
      if(activePlayerId!==item.id||!activePlayer){
        releasePlayer();
        const template=q('[data-pdp-player-template="'+item.id+'"]');
        activePlayer=template?.content.querySelector('video,iframe')?.cloneNode(true)||null;
        if(!activePlayer)return;
        activePlayerId=item.id;activeFrame=document.createElement('div');activeFrame.className='lnp-video-shell';activeFrame.append(activePlayer);created=true;
        if(activePlayer.tagName==='VIDEO'){
          const video=activePlayer,label=root.dataset.videoLabel||say('play_video','Reproducir video');
          video.controls=true;video.playsInline=true;video.preload='metadata';video.autoplay=false;enableVideoAudio(video);
          video.setAttribute('controls','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');video.removeAttribute('autoplay');
          const mp4=[...video.querySelectorAll('source')].filter(source=>source.type==='video/mp4');
          mp4.reverse().forEach(source=>video.prepend(source));
          activePlayButton=document.createElement('button');activePlayButton.type='button';activePlayButton.className='lnp-video-play';activePlayButton.dataset.pdpVideoPlay='';
          activePlayButton.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7Z"></path></svg><span></span>';
          setPlayLabel(label);activeFrame.append(activePlayButton);
          playerController=new AbortController();const options={signal:playerController.signal};
          video.addEventListener('playing',()=>{if(activePlayer===video&&activePlayButton)activePlayButton.hidden=true},options);
          const showPlay=()=>{if(activePlayer===video&&activePlayButton){activePlayButton.hidden=false;setPlayLabel(label)}};
          video.addEventListener('pause',showPlay,options);video.addEventListener('ended',showPlay,options);
          video.addEventListener('error',()=>{if(activePlayer===video&&activePlayButton){activePlayButton.hidden=false;setPlayLabel(say('video_retry','No se pudo iniciar. Toca para reintentar.'))}},options);
          video.addEventListener('loadedmetadata',()=>{if(activePlayer===video)fitCurrentPlayer()},options);
        }
      }
      holders.forEach(node=>node.hidden=node!==holder);
      if(activeFrame.parentElement!==holder){
        if(activePlayer.tagName==='VIDEO'&&!created)activePlayer.pause();holder.append(activeFrame);
        playerSizeObserver?.disconnect();
        if('ResizeObserver'in window){playerSizeObserver=new ResizeObserver(fitCurrentPlayer);playerSizeObserver.observe(holder)}
      }
      fitCurrentPlayer();
      if(created&&activePlayer.tagName==='VIDEO')activePlayer.load();
    }
    function showMedia(index,announce=false){
      if(!gallery.length)return;
      const next=(index+gallery.length)%gallery.length;if(next!==galleryIndex)releasePlayer();galleryIndex=next;
      const item=gallery[galleryIndex],isVideo=item.type==='video'||item.type==='external_video';
      qa('[data-pdp-thumb]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.pdpThumb)===galleryIndex)));
      qa('[data-pdp-image-count]').forEach(el=>el.textContent=(galleryIndex+1)+' / '+gallery.length);
      qa('[data-pdp-prev],[data-pdp-next]').forEach(button=>button.disabled=gallery.length<2);
      qa('[data-pdp-image],[data-pdp-zoom-image]').forEach(photo=>{
        photo.hidden=isVideo;
        if(!isVideo&&photo.getAttribute('src')!==item.url){photo.removeAttribute('srcset');photo.src=item.url}
        photo.alt=item.alt||product.title;
      });
      const dock=q('[data-pdp-dock-image]');if(dock&&item.url){dock.src=item.url;dock.alt=item.alt||product.title;dock.hidden=false}
      const stage=q('.lnp-stage');stage?.classList.toggle('is-video',isVideo);
      q('.lnp-zoom-stage')?.classList.remove('is-magnified');
      const magnify=q('[data-pdp-magnify]');if(magnify){magnify.hidden=isVideo;magnify.setAttribute('aria-pressed','false')}
      syncPlayer();if(item.type==='video')playCurrentVideo();
      const thumb=q('[data-pdp-thumb="'+galleryIndex+'"]'),bar=q('.lnp-thumbs');
      if(thumb&&bar){const left=bar.scrollLeft+thumb.getBoundingClientRect().left-bar.getBoundingClientRect().left-bar.clientWidth/2+thumb.clientWidth/2;bar.scrollTo?.({left,behavior:motion.matches?'instant':'smooth'})}
      if(announce)track(isVideo?'gallery_video':'gallery_image',{image_index:galleryIndex,media_id:item.id,media_type:item.type});
    }
    function imageKey(url){try{return new URL(url,location.origin).pathname.replace(/_(?:\d+x\d*|x\d+)(?=\.[^.]+$)/,'')}catch{return url}}
    function imageForSelection(){const chosen=current()||matches().find(v=>v.image);if(chosen?.image){const index=gallery.findIndex(item=>item.type==='image'&&imageKey(item.url)===imageKey(chosen.image));if(index>=0)showMedia(index)}}
    function setInitial(){
      const variantId=new URL(location.href).searchParams.get('variant');const v=product.variants.find(v=>String(v.id)===variantId);
      if(v)selected=[...v.options];else{const base=product.variants.filter(v=>native?v.buyable:v.available).sort((a,b)=>a.price-b.price)[0]||product.variants[0];selected=product.options.map((name,i)=>kind(name)==='size'&&new Set(product.variants.map(v=>v.options[i])).size>1?null:base.options[i]);}
      reconcile();renderOptions();update();showMedia(0);if(v||gallery[0]?.type==='image')imageForSelection();
    }
    function updateUrl(){const url=new URL(location.href),v=current();if(v)url.searchParams.set('variant',v.id);else url.searchParams.delete('variant');history.replaceState({},'',url.pathname+url.search+url.hash)}
    function update(){
      const v=current(),candidates=matches(),price=v?v.price:candidates.length?Math.min(...candidates.map(v=>v.price)):Math.min(...product.variants.map(v=>v.price));
      const varies=!v&&candidates.some(v=>v.price!==price),formatted=(varies?say('from','Desde')+' ':'')+money(price)+' '+currency;
      q('[data-pdp-price]').textContent=formatted;
      if(v&&v.compareAt>v.price){const s=document.createElement('s');s.textContent=money(v.compareAt);q('[data-pdp-price]').append(s)}
      q('[data-pdp-dock-price]').textContent=formatted;
      const summary=selected.filter(v=>v&&v!=='Default Title').join(' · ');q('[data-pdp-dock-options]').textContent=summary||product.shortTitle||product.title;
      q('.lnp-dock').dataset.fullSize=String(optionOrder.some(option=>option.kind==='size'&&selected[option.index]&&fullSizeLabel(selected[option.index])));
      qa('[data-pdp-advice]').forEach(anchor=>{const url=new URL(root.dataset.advice||'https://wa.me/525646646570');url.searchParams.set('text',say('advice_message','Hola, me interesa {product}. {options} ¿Me ayudan a elegir? {url}',{product:product.title,options:summary,url:product.storeUrl||product.url}));anchor.href=url.href});
      q('[data-pdp-shipping-text]').textContent=country==='MX'&&currency==='MXN'&&price*quantity>=150000?say('shipping_free','Envío gratis en México'):say('shipping_checkout','Envío calculado al continuar');
      const material=optionOrder.find(o=>o.kind==='material');if(q('[data-pdp-material]')){q('[data-pdp-material]').hidden=!material&&!product.material;q('[data-pdp-material]').textContent=(material&&selected[material.index])||product.material||say('material_choose','Elige material y calidad');}
      const consult=product.consultOnly||(v&&(native?!v.buyable||v.inventoryKnown&&quantity>v.inventory:!v.available));
      if(journey){
        const showJourney=journeyEnabled&&product.available&&!consult&&candidates.some(candidate=>native?candidate.buyable:candidate.available);
        journey.hidden=!showJourney;
        const deliveryNote=q('[data-pdp-delivery-note]');
        if(deliveryNote)deliveryNote.hidden=showJourney;
        const shippingDetails=q('[data-pdp-shipping-details]');
        if(shippingDetails)shippingDetails.hidden=showJourney;
      }
      const installments=q('[data-pdp-installments]');
      if(installments){
        const installmentEligible=country==='MX'&&currency==='MXN'&&Number.isFinite(price)&&price>=300000&&!consult&&product.available&&candidates.some(candidate=>candidate.price===price&&(native?candidate.buyable:candidate.available));
        const installmentText=installmentEligible?say(varies?'installments_from':'installments',varies?'3 meses sin intereses desde {amount}':'3 meses sin intereses de {amount}',{amount:money(Math.round(price/3))+' '+currency}):'';
        if(installments.textContent!==installmentText)installments.textContent=installmentText;
        installments.hidden=!installmentEligible;
      }
      let label=product.consultOnly?say('request_stock','Solicitar stock'):!v?say('choose_size','Elige tus opciones'):consult?say('consult_availability','Consultar disponibilidad'):native?say('buy_now','Comprar ahora'):say('continue_buy','Continuar a compra');
      if(!v&&!product.consultOnly&&optionOrder.some(o=>o.kind==='size'&&!selected[o.index]))label=say('select_size','Elegir talla');
      qa('[data-pdp-buy]').forEach(button=>{button.textContent=adding?say('adding','Agregando…'):label;button.disabled=adding;button.dataset.mode=product.consultOnly||consult?'consult':!v?'select':native?'buy':'preview'});
      const secondary=q('[data-pdp-add]');if(secondary){secondary.hidden=!native||product.consultOnly||Boolean(consult);secondary.disabled=!v||adding}
      q('[data-pdp-actions]').classList.toggle('is-consult',product.consultOnly);q('[data-pdp-quantity]').hidden=product.consultOnly;
      const status=q('[data-pdp-availability]');status.dataset.state=consult?'consult':'default';
      status.textContent=product.consultOnly?say('stetson_stock','Confirmamos modelo, color, talla y plazo por WhatsApp.'):!v?say('options_prompt','Elige tu talla y revisa las opciones antes de continuar.'):consult?say('not_available','Esta selección requiere confirmar disponibilidad con nuestro equipo.'):native?say('stock_registered','Disponible en la variante seleccionada. Revisa el tiempo de preparación.'):say('preview_availability','Confirma disponibilidad actualizada al continuar en la tienda.');
      const eligible=product.available&&(!v||(native?v.buyable:v.available))&&!product.consultOnly&&currency==='MXN';
      const gift=q('[data-pdp-gift]');if(gift)gift.hidden=!product.gift||!eligible;
      const offers=q('[data-pdp-offers]');if(offers)offers.hidden=!gift||gift.hidden;
      schedule();
    }
    function focusOptions(){const missing=optionOrder.find(o=>!selected[o.index]);const dest=missing?q('[data-option-group="'+missing.index+'"]'):q('[data-pdp-form]');dest.scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'center'});dest.querySelector('button:not(:disabled)')?.focus({preventScroll:true})}
    function consult(){const values=selected.filter(v=>v&&v!=='Default Title');const message=say('whatsapp_message','Hola, me interesa {product}. {options} ¿Me confirman disponibilidad, preparación y precio? {url}',{product:product.title,options:values.length?values.join(' / ')+'.':'',url:product.storeUrl||product.url});const url=new URL(root.dataset.advice||'https://wa.me/525646646570');url.searchParams.set('text',message);location.assign(url.href)}
    function parseJson(text){
      if(typeof text!=='string'||!text.trim())return null;
      try{return JSON.parse(text)}catch{return null}
    }
    function cartPath(endpoint){
      const base=window.Shopify?.routes?.root||root.dataset.rootUrl||'/';
      return base.replace(/\/?$/,'/')+endpoint;
    }
    function cartDestination(){return root.dataset.cartUrl||cartPath('cart')}
    async function request(url,options={}){
      const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),15000);
      try{
        const response=await fetch(url,{...options,credentials:'same-origin',signal:abort.signal});
        const text=await response.text();
        return {response,text};
      }finally{clearTimeout(timer)}
    }
    function freshProduct(html){
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=parseJson(doc.querySelector('[data-pdp-json]')?.textContent);
      if(!fresh||!Array.isArray(fresh.variants)||!fresh.variants.length)return null;
      if(product.id!=null&&String(fresh.id)!==String(product.id))return null;
      if(!fresh.variants.every(v=>v&&v.id!=null&&Number.isFinite(v.price)&&typeof v.buyable==='boolean'&&(!v.inventoryKnown||Number.isFinite(v.inventory))))return null;
      return fresh;
    }
    async function loadFresh(){
      const url=new URL(location.href);
      url.hash='';url.searchParams.delete('view');url.searchParams.delete('sections');url.searchParams.delete('section_id');
      const sectionId=root.dataset.sectionId;
      const candidates=[];
      if(sectionId){const sectionUrl=new URL(url);sectionUrl.searchParams.set('section_id',sectionId);candidates.push(sectionUrl)}
      candidates.push(url);
      for(const candidate of candidates){
        try{
          const {response,text}=await request(candidate,{cache:'no-store',headers:{Accept:'text/html'}});
          const fresh=response.ok?freshProduct(text):null;
          if(fresh)return fresh;
        }catch{}
      }
      throw Error('availability');
    }
    async function purchase(goToCart){
      if(adding)return;
      const status=q('[data-pdp-availability]');status.classList.remove('lnp-error');
      const v=current();if(product.consultOnly){consult();return}if(!v){focusOptions();return}
      if((native?!v.buyable:!v.available)||(native&&v.inventoryKnown&&quantity>v.inventory)){consult();return}
      if(!native){const url=new URL(product.storeUrl);url.searchParams.set('variant',v.id);location.assign(url.href);return}
      adding=true;update();q('[data-pdp-cart-result]').hidden=true;
      const id=v.id,price=v.price,requestedQuantity=quantity;let notice='',stage='check',leaving=false;
      try{
        const fresh=await loadFresh(),variant=fresh.variants.find(x=>String(x.id)===String(id));
        if(!variant)throw Error('availability');
        product=fresh;
        if(fresh.consultOnly||!variant.buyable||variant.inventoryKnown&&requestedQuantity>variant.inventory){adding=false;renderOptions();update();return}
        if(variant.price!==price){adding=false;renderOptions();update();notice=say('price_changed','El precio cambió. Revisa el importe antes de continuar.');return}
        stage='add';
        let response,text;
        try{
          ({response,text}=await request(cartPath('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:requestedQuantity}]})}));
        }catch{
          leaving=true;location.assign(cartDestination());return;
        }
        const result=parseJson(text);
        if(!response.ok){
          if(response.status>=500){leaving=true;location.assign(cartDestination());return}
          throw Error('add');
        }
        const items=Array.isArray(result?.items)?result.items:result?.id?[result]:[];
        if(!items.some(item=>String(item.variant_id??item.id)===String(id)&&Number(item.quantity)>0)){
          leaving=true;location.assign(cartDestination());return;
        }
        try{track('add_to_cart_success',{variant_id:id,quantity:requestedQuantity})}catch{}
        if(goToCart){leaving=true;location.assign(cartDestination());return}
        q('[data-pdp-cart-result]').hidden=false;q('[data-pdp-cart-result]').focus({preventScroll:true});
        try{
          const {response,text}=await request(cartPath('cart.js'),{cache:'no-store',headers:{Accept:'application/json'}});
          const cart=response.ok?parseJson(text):null;
          if(cart&&Number.isFinite(cart.item_count)){qa('[data-pdp-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=!cart.item_count});document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}))}
        }catch{}
      }catch{
        status.textContent=stage==='check'?say('check_failed','No pudimos confirmar la disponibilidad. Intenta de nuevo.'):say('add_failed','No pudimos agregar tu selección. Revisa la talla y la cantidad e intenta de nuevo.');
        status.dataset.state='error';status.classList.add('lnp-error');
      }finally{
        if(!leaving){
          adding=false;qa('[data-pdp-buy]').forEach(button=>button.disabled=false);
          if(!status.classList.contains('lnp-error'))update();else qa('[data-pdp-buy]').forEach(button=>button.textContent=say('retry','Intentar de nuevo'));
          if(q('[data-pdp-add]'))q('[data-pdp-add]').disabled=false;
          if(notice){status.textContent=notice;status.dataset.state='notice'}
        }
      }
    }
    on(root,'click',event=>{
      const target=event.target.closest('button,a,dialog');if(!target)return;
      if(target.matches('dialog')){const rect=target.getBoundingClientRect();if(event.target===target&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))target.close();return}
      if(target.hasAttribute('data-close')){target.closest('dialog').close();return}
      if(target.dataset.dialog){event.preventDefault();openDialog(target.dataset.dialog,target);return}
      if(target.hasAttribute('data-pdp-guide')){event.preventDefault();openDialog('size');return}
      if(target.hasAttribute('data-pdp-option')){if(adding)return;const index=Number(target.dataset.pdpOption);selected[index]=target.dataset.pdpValue;reconcile();renderOptions();q('[data-pdp-cart-result]').hidden=true;q('[data-pdp-availability]').classList.remove('lnp-error');update();updateUrl();imageForSelection();qa('[data-pdp-option]').find(b=>Number(b.dataset.pdpOption)===index&&b.dataset.pdpValue===selected[index])?.focus({preventScroll:true});track('variant_option',{option:product.options[index],choice:selected[index]});return}
      if(target.hasAttribute('data-pdp-video-play')){event.preventDefault();playCurrentVideo();return}
      if(target.hasAttribute('data-pdp-thumb')){showMedia(Number(target.dataset.pdpThumb),true);return}
      if(target.hasAttribute('data-pdp-prev')){showMedia(galleryIndex-1,true);return}
      if(target.hasAttribute('data-pdp-next')){showMedia(galleryIndex+1,true);return}
      if(target.hasAttribute('data-pdp-magnify')){const stage=q('.lnp-zoom-stage');stage.classList.toggle('is-magnified');target.setAttribute('aria-pressed',String(stage.classList.contains('is-magnified')));return}
      if(target.hasAttribute('data-pdp-minus')||target.hasAttribute('data-pdp-plus')){if(adding)return;quantity=Math.max(1,quantity+(target.hasAttribute('data-pdp-plus')?1:-1));q('[name=quantity]').value=quantity;update();return}
      if(target.hasAttribute('data-pdp-buy')){event.preventDefault();purchase(true);return}
      if(target.hasAttribute('data-pdp-add')){event.preventDefault();purchase(false);return}
      if(target.matches('a[href^="#"]')){const dest=document.getElementById(target.hash.slice(1));if(dest){event.preventDefault();qa('dialog[open]').forEach(d=>d.close());dest.scrollIntoView({behavior:motion.matches?'instant':'smooth'})}}
    });
    on(q('[name=quantity]'),'change',e=>{quantity=Math.max(1,Math.floor(Number(e.target.value)||1));e.target.value=quantity;update()});
    on(q('[data-pdp-form]'),'submit',e=>{e.preventDefault();purchase(true)});
    on(q('[data-measure-form]'),'submit',e=>{
      e.preventDefault();if(!e.target.reportValidity())return;const measure=Number(e.target.elements.measure.value);const sizes=product.options.flatMap((name,i)=>kind(name)==='size'?[...new Set(product.variants.map(v=>Number(v.options[i])).filter(Number.isFinite))]:[]);
      let text=Number.isInteger(measure)?say('fit_whole','Tu talla nominal es {value}. Confirma el ajuste para este modelo.',{value:measure}):say('fit_between','Estás entre {lower} y {upper}. Comparte la medida exacta con nuestro Hatmaker.',{lower:Math.floor(measure),upper:Math.ceil(measure)});
      if(product.family==='sanpalmo'&&product.unitalla)text=measure>=54&&measure<=58?say('fit_unitalla','Tu medida está dentro del rango 54–58 cm de esta unitalla. Confirma el ajuste si estás en un extremo.'):say('fit_outside_unitalla','Tu medida está fuera del rango 54–58 cm. Consúltanos antes de elegir esta pieza.');
      else if(product.unitalla)text=say('fit_unitalla_check','Este modelo es unitalla. Comparte tu medida exacta con un Hatmaker para confirmar el ajuste.');
      else if(sizes.length&&(measure<Math.min(...sizes)||measure>Math.max(...sizes)))text=say('fit_outside','Esta medida queda fuera de las tallas publicadas para este modelo. Nuestro Hatmaker puede ayudarte.');
      q('[data-measure-result]').textContent=text;const url=new URL(root.dataset.advice||'https://wa.me/525646646570');url.searchParams.set('text',say('fit_message','Hola, mi cabeza mide {value} cm y me interesa {product}. ¿Me ayudan a confirmar el ajuste?',{value:measure,product:product.title}));q('[data-measure-whatsapp]').href=url.href;
    });
    let pointer=null;const stage=q('.lnp-stage');on(stage,'pointerdown',e=>{pointer=null;if(e.pointerType==='touch'&&gallery[galleryIndex]?.type==='image'&&!e.target.closest('button,video,iframe,input,[data-pdp-player]'))pointer={x:e.clientX,y:e.clientY}});on(stage,'pointerup',e=>{if(!pointer)return;const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;pointer=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)showMedia(galleryIndex+(dx<0?1:-1),true)});on(stage,'pointercancel',()=>pointer=null);
    on(q('[data-modal=zoom]'),'keydown',e=>{if(e.defaultPrevented||e.target.closest('video,iframe,input,textarea,select,[contenteditable="true"]'))return;if(e.key==='ArrowRight'){e.preventDefault();showMedia(galleryIndex+1,true)}if(e.key==='ArrowLeft'){e.preventDefault();showMedia(galleryIndex-1,true)}});
    let frame=false;function schedule(){if(!frame){frame=true;requestAnimationFrame(scroll)}}
    function scroll(){frame=false;const fixed=scrollY>110;q('.lnw-head')?.classList.toggle('is-scrolled',fixed);q('.lnw-head-space')?.toggleAttribute('hidden',!fixed);const button=q('[data-pdp-actions] [data-pdp-buy]'),rect=button.getBoundingClientRect();q('.lnp-dock').classList.toggle('is-visible',rect.top>innerHeight-90||rect.bottom<75)}
    on(window,'scroll',schedule,{passive:true});on(window,'resize',()=>{schedule();fitCurrentPlayer()},{passive:true});
    let observer=null;if('IntersectionObserver'in window)observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('is-pending');observer.unobserve(e.target)}}),{threshold:.05});
    qa('.lnp-reveal').forEach((el,i)=>{el.style.transitionDelay=(i%3)*65+'ms';if(!motion.matches&&observer){el.classList.add('is-pending');observer.observe(el)}});
    on(motion,'change',()=>{if(motion.matches)qa('.is-pending').forEach(el=>el.classList.remove('is-pending'))});
    on(window,'popstate',setInitial);
    on(window,'pageshow',()=>{adding=false;update();syncPlayer()});
    on(window,'pagehide',releasePlayer);
    on(document,'visibilitychange',()=>{if(document.hidden)pauseMedia();else syncPlayer()});
    on(document,'shopify:section:unload',e=>{if(e.target.contains(root)){const opened=qa('dialog[open]');opened.forEach(dialog=>{skipDialogReturn.add(dialog);dialog.close()});if(opened.length)document.documentElement.style.overflow=oldOverflow;releasePlayer();controller.abort();observer?.disconnect()}});
    setInitial();schedule();
  }
  document.querySelectorAll('[data-ln-product]').forEach(initialize);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ln-product]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-search"] && !Shopify.designMode) return;
  try {
    



(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';
  const arrowPattern=/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?/gu;
  const arrowDirection=char=>({ '←':'left','‹':'left','«':'left','❮':'left','↑':'up','↓':'down','↗':'up-right','↘':'down-right','↖':'up-left','↙':'down-left' }[char]||'right');
  const arrowPaths={right:'M4 12h15m-6-6 6 6-6 6',left:'M20 12H5m6-6-6 6 6 6',up:'M12 20V5m-6 6 6-6 6 6',down:'M12 4v15m-6-6 6 6 6-6','up-right':'M5 19 19 5M7 5h12v12','down-right':'M5 5l14 14M7 19h12V7','up-left':'M19 19 5 5m0 12V5h12','down-left':'M19 5 5 19m0-12v12h12'};
  const makeArrow=character=>{
   const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
   for(const [name,value] of Object.entries({class:'lns-arrow lns-text-arrow',viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(name,value);
   path.setAttribute('d',arrowPaths[arrowDirection(character[0])]);path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;
  };
  const normalizeArrows=(menu=root)=>{
   if(!menu)return;
   menu.querySelectorAll('svg').forEach(svg=>{
    const paths=[...svg.querySelectorAll('path')];
    if(paths.length!==1||!/^(?:m146-6666|m10666-66|m412h15m-6-666-66|m69666-6)$/i.test((paths[0].getAttribute('d')||'').replace(/[\s,]/g,'')))return;
    svg.classList.add('lns-arrow');
    for(const [name,value] of Object.entries({fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round'}))svg.setAttribute(name,value);
    paths[0].setAttribute('fill','none');paths[0].setAttribute('stroke','currentColor');
   });
   const walker=document.createTreeWalker(menu,NodeFilter.SHOW_TEXT),nodes=[];let node;
   while(node=walker.nextNode()){const parent=node.parentElement;if(parent?.closest('a,button,summary')&&!parent.closest('svg,script,style')&&/[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮]/u.test(node.data))nodes.push(node)}
   nodes.forEach(text=>{const fragment=document.createDocumentFragment();let position=0;for(const match of text.data.matchAll(arrowPattern)){fragment.append(document.createTextNode(text.data.slice(position,match.index)),makeArrow(match[0]));position=match.index+match[0].length}fragment.append(document.createTextNode(text.data.slice(position)));text.replaceWith(fragment)});
   menu.querySelectorAll('a,button,summary,a span,button span,summary span').forEach(element=>{
    if(element.closest('svg'))return;
    for(const side of ['before','after']){
     if(element.hasAttribute('data-ln-arrow-'+side))continue;
     let content='';try{content=getComputedStyle(element,'::'+side).content||''}catch{}
     const text=content.replace(/^["']|["']$/g,'').trim();
     if(!/^[→➜➝➞➟➠➡➔➙➛⟶⟹↗↙↖↘←↑↓‹›»«❯❮][\uFE0E\uFE0F]?$/u.test(text))continue;
     element.setAttribute('data-ln-arrow-'+side,'');const svg=makeArrow(text);if(side==='before')element.prepend(svg);else element.append(svg);
    }
   });
  };

normalizeArrows(root);
if(!('IntersectionObserver'in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-pending');observer.unobserve(entry.target)}}),{threshold:.04});root.querySelectorAll('.lns-card').forEach((card,i)=>{if(card.getBoundingClientRect().top>innerHeight){card.classList.add('is-pending');card.style.transitionDelay=(i%4)*55+'ms';observer.observe(card)}});document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))observer.disconnect()},{once:true})}document.querySelectorAll('[data-ln-search]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ln-search]').forEach(init))})();




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln_rastrea_sombrero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ln-raices-tracker')) {
  class LnRaicesTracker extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.q = selector => this.querySelector(selector);
      this.messages = JSON.parse(this.dataset.messages);
      this.demo = this.dataset.demo === 'true';
      this.boundaries = this.dataset.calendar.split(',').map(Number);
      this.closures = new Set(this.dataset.closures.split(/[\s,;]+/).filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date)));
      this.dateParts = new Intl.DateTimeFormat('en-CA',{timeZone:'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit'});
      this.dateLabel = new Intl.DateTimeFormat('es-MX',{timeZone:'UTC',day:'numeric',month:'short'});
      this.labels = ['received','bell','shaping','finishing','packing','shipped'];
      this.notes = this.labels.map(key => `${key}_note`);
      this.sequence = 0;
      if (this.boundaries.length !== 5 || this.boundaries.some((n,i,a) => !Number.isInteger(n) || n < 1 || n > 30 || (i && n <= a[i-1]))) {
        this.showError('config_error'); this.q('[data-submit]').disabled = true; return;
      }
      const on = (target,event,callback) => target.addEventListener(event,callback,{signal:this.controller.signal});
      on(this.q('[data-form]'),'submit',event => {event.preventDefault();this.lookup();});
      on(this.q('[data-another]'),'click',()=>this.reset());
      on(this.q('[data-refresh]'),'click',()=>this.lookup(true));
      on(this.q('[data-form]'),'input',()=>{this.pending?.abort();this.sequence++;this.setBusy(false);this.q('[data-error]').hidden=true;});
      if (this.demo) {
        on(this.q('[data-days]'),'input',()=>this.renderDemo());
        on(this.q('[data-shipping]'),'change',()=>this.renderDemo());
      }
      this.timer = setInterval(()=>this.tick(),60000);
      on(document,'visibilitychange',()=>{if(!document.hidden)this.tick();});
      on(window,'pagehide',()=>this.reset(false));
    }
    disconnectedCallback(){this.controller?.abort();this.pending?.abort();clearInterval(this.timer);this.controller=null;this.credentials=null;this.order=null;}
    showError(key,refresh=false){const target=this.q(refresh?'[data-refresh-error]':'[data-error]');target.textContent=this.text(key);target.hidden=false;}
    setBusy(busy){this.q('[data-submit]').disabled=busy;this.q('[data-refresh]').disabled=busy;this.q('[data-submit-label]').textContent=this.text(busy?'busy':'submit');this.q('[data-form]').setAttribute('aria-busy',String(busy));}
    async lookup(refresh=false){
      if(this.demo){this.renderDemo();return;}
      const form=this.q('[data-form]');
      if(!refresh&&!form.reportValidity())return;
      const credentials=refresh?this.credentials:{order:form.elements.order.value.trim(),email:form.elements.email.value.trim()};
      if(!credentials)return;
      if(!/^[#A-Za-z0-9_\s-]{1,40}$/.test(credentials.order)){this.showError('invalid');return;}
      const endpoint=this.dataset.endpoint;
      if(!/^\/apps\/[a-zA-Z0-9_/-]+$/.test(endpoint)){this.showError('unavailable',refresh);return;}
      this.pending?.abort();this.pending=new AbortController();
      const sequence=++this.sequence;
      const pending=this.pending;
      const timeout=setTimeout(()=>pending.abort(),15000);
      this.setBusy(true);this.q('[data-error]').hidden=true;this.q('[data-refresh-error]').hidden=true;
      try{
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(credentials),credentials:'same-origin',cache:'no-store',redirect:'error',signal:this.pending.signal});
        const payload=await response.json();
        if(sequence!==this.sequence)return;
        if(!response.ok||payload.code!=='OK'){
          const key=payload.code==='RATE_LIMIT'?'rate_limit':payload.code==='NOT_FOUND'?'not_found':payload.code==='INVALID'?'invalid':'unavailable';
          if(refresh&&response.status===404){this.reset(false);this.showError('not_found');}else this.showError(key,refresh);
          return;
        }
        if(!payload.order||!Array.isArray(payload.order.items)||!Number.isFinite(Date.parse(payload.serverNow)))throw new Error('invalid_response');
        this.credentials=credentials;this.order=payload.order;
        this.serverTime=Date.parse(payload.serverNow);this.clockStart=performance.now();this.lastFetch=performance.now();
        if(!refresh)this.sessionStart=performance.now();
        this.render(!refresh);
      }catch(error){if(sequence===this.sequence)this.showError(refresh?'stale':'unavailable',refresh);}
      finally{clearTimeout(timeout);if(sequence===this.sequence)this.setBusy(false);}
    }
    reset(focus=true){
      this.pending?.abort();this.sequence++;this.credentials=null;this.order=null;this.serverTime=null;
      this.q('[data-cards]').replaceChildren();this.q('[data-results]').hidden=true;this.q('[data-lookup]').hidden=false;this.dataset.hasOrder='false';
      this.q('[data-form]').reset();if(!this.demo){this.q('[name="order"]').value='';this.q('[name="email"]').value='';}
      this.setBusy(false);this.q('[data-error]').hidden=true;
      if(focus)this.q('[name="order"]').focus();
    }
    tick(){
      if(!this.order||document.hidden)return;
      if(!this.demo&&performance.now()-this.sessionStart>900000){this.reset(false);this.showError('expired');return;}
      if(this.today()!==this.renderedDay)this.render(false);
    }
    renderDemo(){
      const count=Number(this.q('[data-days]').value);this.q('[data-days-output]').textContent=count;
      const shipped=this.q('[data-shipping]').checked;
      this.order={name:'#1942 · '+this.text('demo_order'),created:this.daysAgo(count)/1000,payment:'paid',items:[{title:this.text('demo_product'),quantity:1,eligible:true,fulfilled:shipped?1:0,shipment:shipped?this.today()/1000:'',tracking:[],image:this.dataset.demoImage||null}]};
      this.render(false);
    }
      text(key, values = {}) {
        return Object.entries(values).reduce((str, [name, value]) => str.replaceAll(`%${name}%`, String(value)), this.messages[key] || '');
      }
      day(date) {
        const parts = Object.fromEntries(this.dateParts.formatToParts(date).map((p) => [p.type, p.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12);
      }
      today() { return this.day(new Date(this.serverTime ? this.serverTime + performance.now() - this.clockStart : Date.now())); }
      fromTimestamp(value) {
        const number = Number(value);
        if (!Number.isFinite(number) || number <= 0) return null;
        const date = new Date(number * 1000);
        return Number.isNaN(date.getTime()) ? null : this.day(date);
      }
      key(day) { return new Date(day).toISOString().slice(0, 10); }
      workday(day) {
        const weekday = new Date(day).getUTCDay();
        return weekday !== 0 && weekday !== 6 && !this.closures.has(this.key(day));
      }
      addDays(day, count) {
        let cursor = day;
        let remaining = count;
        while (remaining > 0) {
          cursor += 86400000;
          if (this.workday(cursor)) remaining -= 1;
        }
        return cursor;
      }
      elapsed(start, end) {
        if (start > end) return 0;
        let days = 0;
        for (let cursor = start + 86400000; cursor <= end; cursor += 86400000) if (this.workday(cursor)) days += 1;
        return days;
      }
      daysAgo(count) {
        let cursor = this.today();
        let remaining = count;
        while (remaining > 0) {
          if (this.workday(cursor)) remaining -= 1;
          cursor -= 86400000;
        }
        return cursor;
      }
      format(day) { return this.dateLabel.format(new Date(day)); }
      safeUrl(raw) {
        if (!raw) return null;
        try {
          const url = new URL(raw, window.location.origin);
          return url.protocol === 'https:' ? url.href : null;
        } catch { return null; }
      }
      state(order, item, start, today) {
        const hold = (key) => ({ key, note:`${key}_note`, stage:null });
        if (order.cancelled) return hold('cancelled');
        if (order.payment === 'refunded') return hold('refunded');
        if (!item.eligible) return hold('unsupported');
        if (order.payment === 'partially_refunded') return hold('changed');
        if (item.fulfilled > 0 && item.fulfilled < item.quantity) return hold('partial');
        if (item.quantity > 0 && item.fulfilled >= item.quantity && this.fromTimestamp(item.shipment)) {
          return { key:order.pickup ? 'pickup' : 'shipped', note:order.pickup ? 'pickup_note' : 'shipped_note', stage:5, confirmed:true };
        }
        if (!['paid','partially_paid','authorized'].includes(order.payment)) return hold('pending');
        if (order.paused) return hold('paused');
        if (!start || start > today) return hold('bad_date');
        const days = this.elapsed(start, today);
        const stage = this.boundaries.slice(0, 4).filter((n) => days >= n).length;
        const late = days > this.boundaries[4];
        return { key:late ? 'late' : this.labels[stage], note:late ? 'late_note' : this.notes[stage], stage, days, late };
      }

    render(scroll=false){
      const order=this.order;if(!order)return;
      const today=this.today();this.renderedDay=today;
      const start=this.fromTimestamp(order.created);
      const fragment=document.createDocumentFragment();
      for(const [index,item] of order.items.entries()){
        const card=this.q('[data-card]').content.firstElementChild.cloneNode(true);
        const q=selector=>card.querySelector(selector);
        const state=item.removed?{key:'changed',note:'changed_note',stage:null}:this.state(order,item,start,today);
        q('[data-product]').textContent=item.title;
        q('[data-quantity]').textContent=this.text('quantity',{count:item.quantity});
        q('[data-bought]').textContent=start?this.text('bought',{date:this.format(start)}):'';
        const image=this.safeUrl(item.image);
        if(image){q('[data-image]').src=image;q('[data-image]').hidden=false;q('[data-hat]').hidden=true;q('[data-image]').addEventListener('error',()=>{q('[data-image]').hidden=true;q('[data-hat]').hidden=false;},{once:true});}
        q('[data-kind]').textContent=this.text(state.confirmed?'confirmed':state.stage===null?'current':'estimated');
        q('[data-status]').textContent=this.text(state.key);
        q('[data-description]').textContent=this.text(state.note);
        const progress=state.stage!==null;
        q('[data-progress]').hidden=!progress;q('[data-percent]').hidden=!progress;
        q('[data-estimate]').hidden=!progress||state.confirmed;
        q('[data-estimate-detail]').hidden=!progress||state.confirmed;
        q('[data-estimate]').id=`${this.id}-estimate-${index}`;
        q('[data-timeline]').hidden=!progress;
        q('[data-eta-wrap]').hidden=!progress||state.confirmed||!start||state.late;
        if(progress){
          const percent=state.stage*20;q('[data-progress]').value=percent;q('[data-percent]').textContent=`${percent}%`;
          q('[data-progress]').setAttribute('aria-label',this.text(state.confirmed?'progress_done':'progress'));
          if(!state.confirmed)q('[data-progress]').setAttribute('aria-describedby',q('[data-estimate]').id);
          if(start&&!state.confirmed&&!state.late)q('[data-eta]').textContent=`${this.format(this.addDays(start,this.boundaries[3]))} — ${this.format(this.addDays(start,this.boundaries[4]))}`;
          this.labels.forEach((key,step)=>{
            const li=document.createElement('li');li.className='ln-rt__step';li.dataset.state=step<state.stage?'past':step===state.stage?'current':'next';
            if(step===state.stage)li.setAttribute('aria-current','step');
            const dot=document.createElement('span');dot.className='ln-rt__dot';dot.setAttribute('aria-hidden','true');
            if(step<state.stage){
              const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.6');
              const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','m5 12 4 4L19 6');svg.append(path);dot.append(svg);
            }else dot.textContent=String(step+1).padStart(2,'0');
            const label=document.createElement('div');const strong=document.createElement('strong');strong.textContent=this.text(step===5&&order.pickup?'pickup':key);label.append(strong);
            const helper=document.createElement('small');helper.textContent=this.text(step===state.stage?'here':step<state.stage?'past_step':'next_step');if(step!==state.stage)helper.className='ln-rt__sr';label.append(helper);
            const range=document.createElement('p');range.textContent=step===0?this.text('day_zero'):step===5?this.text(order.pickup?'pickup_when':'shipping_when'):this.text('day_range',{from:this.boundaries[step-1],to:this.boundaries[step]-(step===4?0:1)});
            if(state.confirmed&&step===5)range.textContent=this.format(this.fromTimestamp(item.shipment));
            li.append(dot,label,range);q('[data-timeline]').append(li);
          });
        }
        if(['shipped','partial'].includes(state.key)){
          (Array.isArray(item.tracking)?item.tracking:[]).forEach((url,index)=>{
            const safe=this.safeUrl(url);if(!safe)return;
            const a=document.createElement('a');a.className='ln-rt__button';a.href=safe;a.rel='noopener noreferrer';a.textContent=this.text('track_link',{count:index+1});q('[data-shipment-links]').append(a);
          });
        }
        fragment.append(card);
      }
      this.q('[data-cards]').replaceChildren(fragment);
      this.q('[data-order-name]').textContent=order.name;
      this.q('[data-lookup]').hidden=true;this.q('[data-results]').hidden=false;this.dataset.hasOrder='true';
      this.q('[data-updated]').textContent=this.text('updated',{time:new Intl.DateTimeFormat('es-MX',{timeZone:'America/Mexico_City',hour:'2-digit',minute:'2-digit'}).format(new Date(this.serverTime||Date.now()))});
      this.q('[data-announcement]').textContent=`${order.name}. ${order.items.map(item=>this.text(this.state(order,item,start,today).key)).join('. ')}`;
      if(scroll){this.q('[name="email"]').blur();this.q('[data-results]').focus({preventScroll:true});this.q('[data-results]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
    }
  }
  customElements.define('ln-raices-tracker',LnRaicesTracker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
